<template>
  <!-- Comienza front end renderizado -->
  <!-- Solo mostrar carpetas (tipo 'c'), los archivos van a la tabla -->
   <!-- El tipo 'r' es el directorio principal, un registro fantasma que no existe en la base de datos pero se considera como la carpeta de volumen para crear más carpetas -->
  <v-list-group  
    v-if="node.tipo === 'c' || node.tipo === 'r'"
    :value="node.tocId"
  > 
<template v-slot:activator="{ props: activatorProps }">
  <!-- Movimiento de carpetas desactivado:
       @pointerdown="handleFolderPointerDown"
  -->
  <v-list-item
    v-bind="getActivatorPropsSinClick(activatorProps)"
    :active="false"
    :title="node.name"
    :prepend-icon="getIconForType(node.tipo)"
    :data-folder-toc-id="node.tipo === 'c' ? node.tocId : null"
    :data-folder-parent-id="node.tipo === 'c' ? node.parentId : null"
    :data-folder-name="node.tipo === 'c' ? node.name : null"
    :class="{
      'tree-folder-selected': selectedFolder?.tocId === node.tocId,
      'tree-folder-draggable': node.tipo === 'c' && !movingFolder,
      'tree-folder-dragging': isFolderDragging
    }"
    @click="handleActivatorClick($event, activatorProps.onClick)"
    @keydown.down.prevent="handleArrowDown($event, activatorProps)"
    @keydown.up.prevent="handleArrowUp($event)"
    @keydown.right.prevent="handleArrowRight"
    @contextmenu.prevent="handleRightClick"
  />
</template>
    
    <!-- Solo renderizar hijos que sean carpetas -->
  <tree-node
    v-for="child in folderChildren"
    :key="child.tocId"
    :node="child"
    :selected-folder="selectedFolder"
    :template-id="templateId"
    :moving-folder="movingFolder"
    @load-subcarpetas="$emit('load-subcarpetas', $event)"
    @folder-selected="$emit('folder-selected', $event)"
    @reload-subcarpetas="$emit('reload-subcarpetas', $event)"
    @folder-move-requested="$emit('folder-move-requested', $event)"
    @cambiar-tab="$emit('cambiar-tab', $event)" 
    @folder-deleted="$emit('folder-deleted', $event)"  
    @enfocar-tabla="$emit('enfocar-tabla')"
  /> <!-- se agrego a cambiar-tab para llamar a otra pagina web -->
  </v-list-group>

  <!-- Menú contextual -->
  <v-menu
    v-model="showContextMenu"
    :style="{ left: menuX + 'px', top: menuY + 'px' }"
    absolute
    offset-y
  >
    <v-list density="compact">
<!--
    <v-list-item @click="importar_carpeta_externa">
        <template v-slot:prepend>
          <v-icon>mdi-folder</v-icon>
        </template>
        <v-list-item-title>Importar carpeta externa</v-list-item-title>
      </v-list-item>
-->
      <v-list-item @click="exportar">
        <template v-slot:prepend>
          <v-icon>mdi-export</v-icon>
        </template>
        <v-list-item-title>Exportar</v-list-item-title>
      </v-list-item>

      <v-list-item @click="propiedades">
        <template v-slot:prepend>
          <v-icon>mdi-information-outline</v-icon>
        </template>
        <v-list-item-title>Propiedades</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="puedeEscribir" @click="indexacion">
        <template v-slot:prepend>
          <v-icon>mdi-text-box-search</v-icon>
        </template>
        <v-list-item-title>Indexación</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="puedeEscribir" @click="reconocimientoIndices">
        <template v-slot:prepend>
          <v-icon>mdi-eye-check</v-icon>
        </template>
        <v-list-item-title>Reconocimiento Indices</v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item v-if="puedeEscribir" @click="crearDirectorio">
        <template v-slot:prepend>
          <v-icon>mdi-folder-plus</v-icon>
        </template>
        <v-list-item-title>Crear directorio</v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Solo mostrar estas opciones si NO es el nodo raíz -->
      <template v-if="node.tipo !== 'r'">
        <v-list-item v-if="puedeEscribir" @click="cambiarNombre">
          <template v-slot:prepend>
            <v-icon>mdi-rename-box</v-icon>
          </template>
          <v-list-item-title>Cambiar nombre</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="puedeEscribir" @click="eliminarDirectorio">
          <template v-slot:prepend>
            <v-icon>mdi-folder-remove</v-icon>
          </template>
          <v-list-item-title>Eliminar Directorio</v-list-item-title>
        </v-list-item>
      </template>

      <v-list-item v-if="AccesoImportar || esAdmin" @click="importarArchivoExterno">
        <template v-slot:prepend>
          <v-icon>mdi-file-import</v-icon>
        </template>
        <v-list-item-title>Importar Archivo Externo</v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item v-if="puedeEscribir" @click="asignarQuitarPermiso">
        <template v-slot:prepend>
          <v-icon>mdi-shield-lock</v-icon>
        </template>
        <v-list-item-title>Asignar o Quitar Permisos</v-list-item-title>
      </v-list-item>

      <v-list-item @click="generarAutoejecutable">
        <template v-slot:prepend>
          <v-icon>mdi-application-export</v-icon>
        </template>
        <v-list-item-title>Generar autoejecutable</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="AccesoBusqueda || esAdmin" @click="busquedaCarpeta">
        <template v-slot:prepend>
          <v-icon>mdi-folder-search</v-icon>
        </template>
        <v-list-item-title>Busqueda en Carpeta</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>



  


<!-- Dialog Asignar/Quitar Permisos -->
<v-dialog v-model="dialogPermisos" max-width="500px" persistent>
  <v-card>
    <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
      Asignar o quitar permisos al directorio
      <v-spacer></v-spacer>
      <v-btn
        icon
        size="small"
        variant="text"
        @click="dialogPermisos = false"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-6">
      <!-- Permiso actual (solo lectura) -->
      <v-text-field
        v-model="permisoActual"
        label="Permiso actual"
        variant="outlined"
        density="comfortable"
        readonly
        :loading="cargandoPermisoActual"
        class="mb-4"
      ></v-text-field>

      <!-- Selector Usuario o grupo -->
      <v-select
        v-model="usuarioSeleccionado"
        :items="usuarios"
        item-title="usuario"
        item-value="idUsuario"
        label="Usuario o grupo"
        variant="outlined"
        density="comfortable"
        placeholder="Seleccione..."
        class="mb-4"
        @update:model-value="cargarPermisoActual"
      ></v-select>

      <!-- Selector Permiso -->
      <v-select
        v-model="permisoSeleccionado"
        :items="tiposPermiso"
        item-title="tipo"
        item-value="idTipoPer"
        label="Permiso"
        variant="outlined"
        density="comfortable"
        placeholder="Sin Acceso"
        class="mb-4"
      ></v-select>
    </v-card-text>

    <v-card-actions class="px-6 pb-4">
      <!-- ✅ Botón Quitar Permiso (solo si tiene permiso) -->
      <v-btn
        v-if="tienePermisoActual"
        variant="flat"
        rounded="lg"
        class="btn-quitar"
        @click="quitarPermiso"
        :disabled="!usuarioSeleccionado"
      >
        Quitar Permiso
      </v-btn>
      
      <v-spacer></v-spacer>
      
      <v-btn
        color="#9B9B9B"
        variant="elevated"
        @click="dialogPermisos = false"
      >
        Cancelar
      </v-btn>
      
      <v-btn
        color="#ce501b"
        variant="elevated"
        @click="guardarPermiso"
        :disabled="!usuarioSeleccionado || !permisoSeleccionado"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>



<!-- Dialog Generar Índices -->
<v-dialog v-model="dialogGenerarIndices" max-width="400px" persistent>
  <v-card>
    <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
      Generar Índices
      <v-spacer></v-spacer>
      <v-btn
        icon
        size="small"
        variant="text"
        @click="dialogGenerarIndices = false"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-6">
      <!-- Selector Columna -->
      <v-select
        v-model="columnaSeleccionada"
        :items="columnas"
        item-title="nombre"
        item-value="id"
        label="Columna"
        variant="outlined"
        density="comfortable"
        placeholder="Seleccione..."
        :loading="cargandoColumnas"
        class="mb-4"
      ></v-select>
    </v-card-text>

    <v-card-actions class="px-6 pb-4">
      <v-spacer></v-spacer>
      <v-btn
        color="#ce501b"
        variant="elevated"
        @click="generarIndices"
        :disabled="!columnaSeleccionada"
      >
        Generar
      </v-btn>
        <v-btn
        color="#9B9B9B"
        variant="elevated"
        @click="dialogGenerarIndices = false"
      >
        Cancelar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


<!-- Dialog Indexación -->
<v-dialog v-model="dialogIndexacion" max-width="1400px" persistent :retain-focus="false" class="dialog-indexacion-carpeta">
  <v-card style="height: 97vh; display: flex; flex-direction: column; overflow: hidden;">

    <!-- Header -->
    <v-card-title class="text-h6 text-white d-flex align-center py-2 px-4"
      style="flex-shrink: 0; background-color: #004d82;">
      <v-icon class="mr-2">mdi-text-box-search</v-icon>
      Indexacion de carpeta
      <v-spacer></v-spacer>
      <v-btn icon size="small" variant="text" @click="cerrarModalIndexacion">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <!-- Cuerpo: split visor izquierda | formulario+lista derecha -->
    <div style="display: flex; flex: 1; overflow: hidden; min-height: 0;">

 

      <!-- ===== PANEL IZQUIERDO: VISOR ===== -->
      <div style="flex: 6; display: flex; flex-direction: column; border-right: 1px solid #e0e0e0; min-height: 0; min-width: 0; overflow: hidden; background: #808080;">

           <!-- ===== BARRA DE ZOOM ===== -->
        <div v-if="urlVisorCarpeta && (esImagenVisorCarpeta || (!esVideoVisorCarpeta && !esAudioVisorCarpeta))"
          style="display:flex; align-items:center; justify-content:center; gap:8px;
                padding:4px 12px; background:#555; flex-shrink:0;">
          
          <button @click="zoomOut" :disabled="zoomLevel <= MIN_ZOOM"
            style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                  border-radius:3px; cursor:pointer; font-size:16px;"
            :style="{ opacity: zoomLevel <= MIN_ZOOM ? '0.3' : '0.9' }"
            title="Alejar">−</button>

          <span style="color:white; font-size:12px; min-width:50px; text-align:center;">
            {{ Math.round(zoomLevel * 100) }}%
          </span>

          <button @click="zoomIn" :disabled="zoomLevel >= MAX_ZOOM"
            style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                  border-radius:3px; cursor:pointer; font-size:16px;"
            :style="{ opacity: zoomLevel >= MAX_ZOOM ? '0.3' : '0.9' }"
            title="Acercar">+</button>

          <button @click="resetZoom"
            style="background:none; border:1px solid #666; color:white; padding:2px 6px;
                  border-radius:3px; cursor:pointer; font-size:11px;"
            title="Restablecer zoom">↺</button>
        </div>


        <!-- Placeholder sin documento seleccionado -->
        <div v-if="!urlVisorCarpeta && !cargandoVisorCarpeta && !errorVisorCarpeta && !archivoNoVisualizableCarpeta"
          style="flex:1; display:flex; align-items:center; justify-content:center;">
          <div class="text-center">
            <v-icon size="64" color="white" style="opacity:0.5;">mdi-file-document-outline</v-icon>
            <p class="text-white mt-2" style="opacity:0.7;">Selecciona un documento para previsualizarlo</p>
          </div>
        </div>

        <!-- Cargando -->
        <div v-else-if="cargandoVisorCarpeta"
          style="flex:1; display:flex; align-items:center; justify-content:center;">
          <div class="text-center">
            <v-progress-circular indeterminate color="white" size="40"></v-progress-circular>
            <p class="text-white mt-2 text-body-2">Cargando documento...</p>
          </div>
        </div>

        <!-- Error -->
        <div v-else-if="errorVisorCarpeta"
          style="flex:1; display:flex; align-items:center; justify-content:center;">
          <div class="text-center">
            <v-icon size="48" color="white">mdi-file-alert-outline</v-icon>
            <p class="text-white mt-2 text-body-2">{{ errorVisorCarpeta }}</p>
          </div>
        </div>

        <!-- Documento Word: descarga disponible, sin intentar renderizar -->
        <div v-else-if="archivoNoVisualizableCarpeta"
          style="flex:1; display:flex; align-items:center; justify-content:center;">
          <div class="text-center px-4">
            <v-icon size="64" color="white">mdi-file-word-outline</v-icon>
            <p class="text-white text-body-1 font-weight-medium mt-3">Documento Word</p>
            <p class="text-white text-body-2 mt-2">Este formato no puede visualizarse directamente.</p>
            <v-btn class="mt-4" color="primary" @click.stop="descargarDocumentoWordCarpeta">
              <v-icon start>mdi-download</v-icon>
              Descargar archivo
            </v-btn>
          </div>
        </div>

      <!-- ✅ Video -->
            <video
              v-else-if="urlVisorCarpeta && esVideoVisorCarpeta"
              :src="urlVisorCarpeta"
              controls
              preload="auto"
              controlsList="nodownload"
              style="flex:1; width:100%; height:100%; background:#000;"
              @error="onErrorMediaCarpeta"
            >
              <source :src="urlVisorCarpeta" :type="mimeVisorCarpeta" />
            </video>

            <!-- ✅ Audio -->
            <div
              v-else-if="urlVisorCarpeta && esAudioVisorCarpeta"
              style="flex:1; display:flex; flex-direction:column; align-items:center;
                    justify-content:center; background:#2a2a2a;"
            >
              <v-icon size="80" color="white" class="mb-4">mdi-music-note</v-icon>
              <p class="text-white text-body-1 mb-4">{{ docSeleccionadoVisor?.nameToc || 'Audio' }}</p>
              <audio
                :src="urlVisorCarpeta"
                controls
                preload="auto"
                style="width:80%; max-width:600px;"
                @error="onErrorMediaCarpeta"
              >
                <source :src="urlVisorCarpeta" :type="mimeVisorCarpeta" />
              </audio>
            </div>

     <!-- Imagen (TIFF convertido o imagen normal) -->
         <div
            v-else-if="urlVisorCarpeta && esImagenVisorCarpeta"
            style="flex:1; overflow:auto; display:flex; justify-content:flex-start;
                  align-items:flex-start; background:#808080;"
            ref="imagenScrollCarpeta"
            :style="{ cursor: isDraggingCarpeta ? 'grabbing' : (zoomEfectivoCarpeta > 1 ? 'grab' : 'default') }"
            @wheel.stop="handleZoomWheelCarpeta"
            @pointerdown="onPointerDownVisorCarpeta"
            @pointermove="onPointerMoveVisorCarpeta"
            @pointerup="onPointerUpVisorCarpeta"
            @pointercancel="onPointerUpVisorCarpeta"
          >
            <div :style="{
              width: Math.round(zoomEfectivoCarpeta * 100) + '%',
              minWidth: Math.round(zoomEfectivoCarpeta * 100) + '%',
              transition: isDraggingCarpeta ? 'none' : 'width 0.15s',
              flexShrink: 0,
              margin: zoomEfectivoCarpeta <= 1 ? '0 auto' : '0'
            }">
              <img
                :src="urlVisorCarpeta"
                style="width:100%; height:auto; display:block; user-select:none; pointer-events:none;"
                alt="Documento"
                draggable="false"
              />
            </div>
          </div>

        <!-- PDF multi-página con scroll continuo -->
        <div v-else-if="urlVisorCarpeta && !esImagenVisorCarpeta"
          style="flex:1; display:flex; flex-direction:column; min-height:0;">

          <!-- Barra de paginación PDF -->
          <div style="display:flex; align-items:center; justify-content:center; gap:8px;
                      padding:6px 12px; background:#424242; flex-shrink:0;">
            <button @click="irAPaginaCarpeta(1)" :disabled="paginaActualCarpeta<=1"
              style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                     border-radius:3px; cursor:pointer; font-size:14px;"
              :style="{ opacity: paginaActualCarpeta<=1 ? '0.3':'0.9' }">«</button>
            <button @click="irAPaginaCarpeta(paginaActualCarpeta-1)" :disabled="paginaActualCarpeta<=1"
              style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                     border-radius:3px; cursor:pointer; font-size:14px;"
              :style="{ opacity: paginaActualCarpeta<=1 ? '0.3':'0.9' }">‹</button>
            <input type="number" :value="paginaActualCarpeta"
              @change="e => irAPaginaCarpeta(parseInt(e.target.value))"
              :min="1" :max="totalPaginasCarpeta"
              style="width:50px; text-align:center; background:#555; border:1px solid #666;
                     color:white; padding:2px 4px; border-radius:3px; font-size:12px;" />
            <span style="color:#ccc; font-size:12px;">de {{ totalPaginasCarpeta }}</span>
            <button @click="irAPaginaCarpeta(paginaActualCarpeta+1)"
              :disabled="paginaActualCarpeta>=totalPaginasCarpeta"
              style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                     border-radius:3px; cursor:pointer; font-size:14px;"
              :style="{ opacity: paginaActualCarpeta>=totalPaginasCarpeta ? '0.3':'0.9' }">›</button>
            <button @click="irAPaginaCarpeta(totalPaginasCarpeta)"
              :disabled="paginaActualCarpeta>=totalPaginasCarpeta"
              style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                     border-radius:3px; cursor:pointer; font-size:14px;"
              :style="{ opacity: paginaActualCarpeta>=totalPaginasCarpeta ? '0.3':'0.9' }">»</button>
            <v-progress-circular v-if="renderizandoCarpeta"
              indeterminate color="white" size="16" width="2"></v-progress-circular>
          </div>
         <!-- Páginas con scroll -->
          <div ref="pdfScrollCarpeta" @scroll="onScrollVisorCarpeta"
                style="flex:1; overflow:auto; background:#808080; padding:8px 0;"
                :style="{ cursor: isDraggingCarpeta ? 'grabbing' : (zoomEfectivoCarpeta > 1 ? 'grab' : 'default') }"
                @wheel.stop="handleZoomWheelCarpeta"
                @pointerdown="onPointerDownVisorCarpeta"
                @pointermove="onPointerMoveVisorCarpeta"
                @pointerup="onPointerUpVisorCarpeta"
                @pointercancel="onPointerUpVisorCarpeta"
              >
        <div v-for="n in totalPaginasCarpeta" :key="'vc-page-'+n"
              :ref="el => { if(el) pdfPageRefsCarpeta[n] = el }"
              :style="{
                padding: '4px 0',
                textAlign: 'center',
                width: zoomLevel <= 1 ? '100%' : 'fit-content',
                minWidth: '100%',
                boxSizing: 'border-box',
                whiteSpace: 'nowrap'
              }">
                <div :style="estiloMarcoPaginaCarpeta(n)">
                  <canvas :id="'visor-carpeta-canvas-'+n"
                    style="width:100%; height:100%; display:block; box-shadow:0 2px 8px rgba(0,0,0,0.4);">
                  </canvas>
                  <div :id="'visor-carpeta-textlayer-'+n" class="textLayer" :style="estiloTextLayerPaginaCarpeta(n)"></div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== PANEL DERECHO: FORMULARIO + LISTA ===== -->
      <div style="flex: 4; display:flex; flex-direction:column; min-height:0; overflow:hidden;">

        <!-- Scroll interno -->
        <div style="flex:1; overflow-y:auto; padding:16px; min-height:0;">

          <!-- Formulario dinámico -->
          <v-row v-if="!cargandoEstructura" class="mb-2">
            <v-col v-for="(campo, idx) in estructuraPlantilla" :key="campo.column_name" cols="12" md="6">
              <v-select v-if="campo.valores"
                :ref="el => setPrimerCampo(el, idx)"
                v-model="valoresIndexacion[campo.column_name]"
                :items="getOpcionesCombo(campo.valores)"
                :label="campo.column_name"
                variant="outlined" density="comfortable" clearable 
                @keydown="handleKeyMetadata"
                />
              <v-text-field v-else-if="esCampoFecha(campo.data_type)"
                :ref="el => setPrimerCampo(el, idx)"
                v-model="valoresIndexacion[campo.column_name]"
                :label="campo.column_name"
                type="date" variant="outlined" density="comfortable" clearable
                @keydown="handleKeyMetadata" />
              <v-text-field v-else
                :ref="el => setPrimerCampo(el, idx)"
                v-model="valoresIndexacion[campo.column_name]"
                :label="campo.column_name"
                :maxlength="campo.length"
                variant="outlined" density="comfortable" clearable
                @keydown="handleKeyMetadata"
                />
            </v-col>
          </v-row>

          <div v-else class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="mt-2">Cargando estructura...</p>
          </div>

          <v-divider class="my-3"></v-divider>

          <!-- Tabs No indexados / Indexados -->
          <v-tabs v-model="tabIndexacion" color="primary" align-tabs="start">
            <v-tab value="no-indexados">No indexados</v-tab>
            <v-tab value="indexados">Indexados</v-tab>
          </v-tabs>

          <v-window v-model="tabIndexacion" class="mt-3">

            <!-- Tab No indexados -->
            <v-window-item value="no-indexados">
              <v-card flat class="pa-3" style="border: 1px solid #e0e0e0;">

                <div v-if="cargandoDocumentos" class="text-center py-4">
                  <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                  <p class="mt-2 text-caption">Cargando documentos...</p>
                </div>

                <div v-else-if="documentosNoIndexados.length > 0">
                  <div class="d-flex align-center mb-2">
                    <v-chip color="primary" size="small" class="mr-3">
                      {{ documentosSeleccionados.length }} / {{ documentosNoIndexados.length }}
                    </v-chip>
                    <v-checkbox
                      :model-value="documentosSeleccionados.length === documentosNoIndexados.length"
                      :indeterminate="documentosSeleccionados.length > 0 && documentosSeleccionados.length < documentosNoIndexados.length"
                      label="Seleccionar todos"
                      density="compact" hide-details
                      @update:model-value="toggleSeleccionarTodos" />
                  </div>
                  <v-divider class="mb-2"></v-divider>
                   <div 
                      ref="listaDocumentosRef"
                      style="max-height: 250px; overflow-y: auto; overflow-x: auto; outline: none;"
                      tabindex="0"
                      @keydown.stop="handleKeyListado"
                    >
                    <v-virtual-scroll
                      ref="virtualNoIndexadosRef"
                      :items="documentosNoIndexados"
                      height="250"
                      item-height="44"
                    >
                      <template #default="{ item: doc, index }">
                        <v-list-item
                          :key="doc.tocId"
                          tabindex="-1"
                          class="text-body-2"
                          :class="{
                            'bg-blue-lighten-5': docSeleccionadoVisor?.tocId === doc.tocId,
                            'doc-item-focused': indiceFocusLista === index
                          }"
                          @click="verDocumento(doc, index)"
                          style="cursor: pointer;"
                        >
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :model-value="documentosSeleccionados.includes(doc.tocId)"
                              color="primary"
                              @click.stop="toggleDocumento(doc.tocId)" />
                          </template>
                          <v-list-item-title>{{ doc.nameToc }}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-virtual-scroll>
                  </div>
                </div>

                <div v-else class="text-center py-4">
                  <v-icon size="48" color="grey-lighten-1">mdi-file-document-check</v-icon>
                  <p class="text-body-2 text-grey mt-2">No hay documentos sin indexar</p>
                </div>
              </v-card>
            </v-window-item>

            <!-- Tab Indexados -->
            <v-window-item value="indexados">
              <v-card flat class="pa-3" style="border: 1px solid #e0e0e0;">
                <div v-if="cargandoDocumentos" class="text-center py-4">
                  <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                  <p class="mt-2 text-caption">Cargando documentos...</p>
                </div>
             <div v-else-if="documentosIndexados.length > 0">
                  <div class="d-flex align-center mb-2">
                    <v-chip color="success" size="small" class="mr-3">
                      {{ documentosIndexadosSeleccionados.length }} / {{ documentosIndexados.length }}
                    </v-chip>
                    <v-checkbox
                      :model-value="documentosIndexadosSeleccionados.length === documentosIndexados.length"
                      :indeterminate="documentosIndexadosSeleccionados.length > 0 && documentosIndexadosSeleccionados.length < documentosIndexados.length"
                      label="Seleccionar todos"
                      density="compact" hide-details
                      @update:model-value="toggleSeleccionarTodosIndexados" />
                    <v-chip v-if="modoSeleccionDesindexar" color="warning" size="small" variant="tonal" class="ml-3">
                      Desindexación activada (Alt + X)
                    </v-chip>
                  </div>
                  <v-divider class="mb-2"></v-divider>
                  <div
                    ref="listaIndexadosRef"
                    style="max-height: 250px; overflow-y: auto; overflow-x: auto; outline: none;"
                    tabindex="0"
                    @keydown.stop="handleKeyListaIndexados"
                  >
                    <v-virtual-scroll
                      ref="virtualIndexadosRef"
                      :items="documentosIndexados"
                      height="250"
                      item-height="44"
                    >
                      <template #default="{ item: doc, index }">
                        <v-list-item
                          :key="doc.tocId"
                          tabindex="-1"
                          class="text-body-2"
                          :class="{
                            'bg-blue-lighten-5': docSeleccionadoVisor?.tocId === doc.tocId,
                            'doc-item-focused': indiceFocusListaIndexados === index
                          }"
                          @click="verDocumentoIndexado(doc, index)"
                          style="cursor: pointer;"
                        >
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :model-value="documentosIndexadosSeleccionados.includes(doc.tocId)"
                              color="warning"
                              @click.stop="toggleDocumentoIndexado(doc.tocId)" />
                            <v-icon size="small" color="success" class="mr-1">mdi-file-document-check</v-icon>
                          </template>
                          <v-list-item-title>{{ doc.nameToc }}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-virtual-scroll>
                  </div>
                </div>
                <div v-else class="text-center py-4">
                  <v-icon size="48" color="grey-lighten-1">mdi-file-document-outline</v-icon>
                  <p class="text-body-2 text-grey mt-2">No hay documentos indexados</p>
                </div>
              </v-card>
            </v-window-item>

          </v-window>
        </div>

        <!-- Botones fijos -->
          <div 
            class="d-flex align-center px-4 py-3" 
            style="border-top: 1px solid #e0e0e0; flex-shrink: 0;"
            @keydown="handleKeyBotones"
          >
            <v-btn 
              ref="btnGuardarRef"
              color="#ce501b" 
              variant="elevated"
              tabindex="0"
              :disabled="cargandoEstructura"
              @click="guardarIndexacion"
              @focus="indiceFocusBotones = 0"
              :class="{ 'btn-focused': indiceFocusBotones === 0 }"
            >
              {{ documentosIndexadosSeleccionados.length > 0 ? 'Desindexar' : 'Guardar' }}
            </v-btn>
            <v-btn 
              ref="btnCancelarRef"
              color="#9B9B9B" 
              variant="text" 
              class="ml-2"
              tabindex="0"
              @click="cerrarModalIndexacion"
              @focus="indiceFocusBotones = 1"
              :class="{ 'btn-focused': indiceFocusBotones === 1 }"
            >
              Cancelar
            </v-btn>
          </div>

      </div>
    </div>
  </v-card>
</v-dialog>




</template>

<script setup>
import { defineProps, defineEmits, computed, ref, onMounted, onUnmounted, shallowRef, nextTick, watch } from 'vue';
import Swal from 'sweetalert2';
//import axios from 'axios';
import { useDescargas } from './Usedescargas'
import { useImportarMinimizado } from './useImportarMinimizado'
import axios from '@/plugins/axios'
import { buildApiUrl } from '@/config/api'
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';
import UTIF from 'utif';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
const canvasHeights = ref({})

// ── Variables de zoom ──
const zoomLevel = ref(1)
const MIN_ZOOM = 0.5
const MAX_ZOOM = 3
const ZOOM_RENDER_DEBOUNCE_MS = 180
const zoomEnCursoCarpeta = ref(false) //Este codigo es para mejorar la velocidad del zoom en el visor de PDF, evitando renderizados innecesarios mientras el usuario ajusta el nivel de zoom.
const MAX_PAGINAS_PDF_RENDERIZADAS = 5
const zoomEfectivoCarpeta = computed(() =>
  Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, zoomLevel.value))
)
const dimsBasePaginasCarpeta = ref({})
const zoomRenderPaginaCarpeta = ref({})
const zoomTextLayerCarpeta = ref({}) //Esto nos sirve para mejorar la velocidad, lo que hace es: n: zoom al que se construyo el text layer
const textContentCacheCarpeta = ref({})
const imagenScrollCarpeta = ref(null)

const handleArrowRight = () => {
  emit('enfocar-tabla')
}

const contenedorZoomActivoCarpeta = () => (
  esImagenVisorCarpeta.value ? imagenScrollCarpeta.value : pdfScrollCarpeta.value
)
const zoomIn = () => aplicarZoomEnPuntoCarpeta(zoomLevel.value + 0.25, null, null, contenedorZoomActivoCarpeta())
const zoomOut = () => aplicarZoomEnPuntoCarpeta(zoomLevel.value - 0.25, null, null, contenedorZoomActivoCarpeta())
const resetZoom = () => aplicarZoomEnPuntoCarpeta(1, null, null, contenedorZoomActivoCarpeta())

const isDraggingCarpeta = ref(false)
const dragStartXCarpeta = ref(0)
const dragStartYCarpeta = ref(0)
const scrollStartXCarpeta = ref(0)
const scrollStartYCarpeta = ref(0)
let pointerIdArrastreCarpeta = null

const primerCampoRef = ref(null)

// Enfocar el primer campo del formulario tras guardar

// ✅ Modo selección por rango (se activa con Ctrl+Alt+R)
const indiceAnclaSeleccion = ref(-1)

const enfocarPrimerCampo = () => {
  nextTick(() => {
    let intentos = 0
    const intentar = () => {
      intentos++
      // El componente Vuetify expone su <input> real en $el
      const wrapper = primerCampoRef.value?.$el
      const input = wrapper?.querySelector('input, textarea')
      if (input) {
        document.activeElement?.blur?.()
        input.focus()
        input.select?.()
      } else if (intentos < 15) {
        setTimeout(intentar, 100)
      }
    }
    setTimeout(intentar, 200)
  })
}


const setPrimerCampo = (el, idx) => {
  if (idx === 0 && el) {
    primerCampoRef.value = el
  }
}


const aplicarZoomEnPuntoCarpeta = async (nuevoZoom, puntoX = null, puntoY = null, container = null) => {
  const contenedor = container || contenedorZoomActivoCarpeta()
  const zoomAnterior = zoomEfectivoCarpeta.value
  const zoomNuevo = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, nuevoZoom))
  const scrollTopAnterior = contenedor?.scrollTop || 0
  const scrollLeftAnterior = contenedor?.scrollLeft || 0
  const px = puntoX ?? (contenedor ? contenedor.clientWidth / 2 : 0)
  const py = puntoY ?? (contenedor ? contenedor.clientHeight / 2 : 0)
  zoomLevel.value = zoomNuevo
  if (!contenedor || zoomAnterior === zoomNuevo) return
  await nextTick()
  const relacion = zoomNuevo / zoomAnterior
  contenedor.scrollTop = Math.max(0, (scrollTopAnterior + py) * relacion - py)
  contenedor.scrollLeft = Math.max(0, (scrollLeftAnterior + px) * relacion - px)
}

const handleZoomWheelCarpeta = (event) => {
  if (!urlVisorCarpeta.value) return
  if (esVideoVisorCarpeta.value || esAudioVisorCarpeta.value) return
  if (!esImagenVisorCarpeta.value) {
    if (!event.ctrlKey) return
    event.preventDefault()
  } else {
    event.preventDefault()
  }
  const rect = event.currentTarget.getBoundingClientRect()
  aplicarZoomEnPuntoCarpeta(
    zoomLevel.value + (event.deltaY < 0 ? 0.1 : -0.1),
    event.clientX - rect.left,
    event.clientY - rect.top,
    event.currentTarget
  )
}

let zoomWatchTimeout = null
watch(zoomLevel, (nuevoZoom) => {
  if (!pdfDocCarpeta.value || esImagenVisorCarpeta.value) return
    zoomEnCursoCarpeta.value = true //Este codigo es para mejorar la velocidad del zoom en el visor de PDF, evitando renderizados innecesarios mientras el usuario ajusta el nivel de zoom.
  if (zoomWatchTimeout) clearTimeout(zoomWatchTimeout)
  zoomWatchTimeout = setTimeout(() => {
    reRenderizarPdfCarpetaPorZoom(nuevoZoom)
  }, ZOOM_RENDER_DEBOUNCE_MS)
})

const onPointerDownVisorCarpeta = event => {
  if (
    event.button !== 0 ||
    zoomEfectivoCarpeta.value <= 1
  ) {
    return
  }

  // Permitir seleccionar texto al pulsar directamente sobre una palabra,
  // pero no bloquear el arrastre en toda la superficie del PDF.
  if (
    event.target.closest?.(
      '.textLayer span, a, button, input, textarea, select'
    )
  ) {
    return
  }

  const el = event.currentTarget

  isDraggingCarpeta.value = true
  pointerIdArrastreCarpeta = event.pointerId

  dragStartXCarpeta.value = event.clientX
  dragStartYCarpeta.value = event.clientY

  scrollStartXCarpeta.value = el.scrollLeft
  scrollStartYCarpeta.value = el.scrollTop

  el.setPointerCapture(event.pointerId)
  event.preventDefault()
}

const onPointerMoveVisorCarpeta = (event) => {
  if (!isDraggingCarpeta.value || event.pointerId !== pointerIdArrastreCarpeta) return
  const el = event.currentTarget
  if (!el) return
  el.scrollLeft = scrollStartXCarpeta.value - (event.clientX - dragStartXCarpeta.value)
  el.scrollTop = scrollStartYCarpeta.value - (event.clientY - dragStartYCarpeta.value)
}

const onPointerUpVisorCarpeta = (event) => {
  if (event.pointerId !== pointerIdArrastreCarpeta) return
  const el = event.currentTarget
  if (el?.hasPointerCapture?.(event.pointerId)) el.releasePointerCapture(event.pointerId)
  isDraggingCarpeta.value = false
  pointerIdArrastreCarpeta = null
}


const onErrorMediaCarpeta = (event) => {
  // MEDIA_ERR_ABORTED (code 1) es normal al hacer seek — ignorar
  if (event.target?.error?.code === 1) return
  console.warn('Error en reproductor carpeta:', event.target?.error)
}

const AccesoBusqueda = ref(false)
const esTipoPer = ref(0)
const esAdmin = ref(false)

// Permisos efectivos sobre la carpeta actual
const puedeEscribir = computed(() => esTipoPer.value === 2 || esAdmin.value)
//const puedeLeer     = computed(() => esTipoPer.value >= 1 || esAdmin.value)

// Definir props (SOLO UNA VEZ)
const props = defineProps({
  node: {
    type: Object,
    required: true
  },
  selectedFolder: {
    type: Object,
    default: null
  },
  depth: {
    type: Number,
    default: 0
  },
  templateId: {  // ✅ Con templateId incluido
    type: [Number, String],
    default: null
  },
  movingFolder: {
    type: Boolean,
    default: false
  }
});

// Definir eventos que puede emitir el componente
const emit = defineEmits(['load-subcarpetas', 'folder-selected', 'show-context-menu', 'reload-subcarpetas', 'cambiar-tab', 'folder-deleted', 'enfocar-tabla', 'expand-node' ,'folder-move-requested']);

const movingFolder = computed(() => props.movingFolder)
const isFolderDragging = ref(false)
const ignorarClickDespuesDrag = ref(false)
const UMBRAL_ARRASTRE_CARPETA = 6

const sesionPointerCarpeta = {
  pointerId: null,
  startX: 0,
  startY: 0,
  origen: null,
  filaOrigen: null,
  descendientesVisibles: [],
  arrastreActivo: false,
  destinoActivo: null,
  tarjetaFlotante: null
}

const obtenerDescendientesVisibles = (node, ids = []) => {
  for (const child of node?.children || []) {
    ids.push(child.tocId)
    obtenerDescendientesVisibles(child, ids)
  }
  return ids
}

const actualizarDestinoActivo = (filaDestino) => {
  if (sesionPointerCarpeta.destinoActivo === filaDestino) return

  sesionPointerCarpeta.destinoActivo?.classList.remove('tree-folder-drop-target')
  sesionPointerCarpeta.destinoActivo = filaDestino
  sesionPointerCarpeta.destinoActivo?.classList.add('tree-folder-drop-target')
}

const actualizarPosicionTarjeta = (event) => {
  if (!sesionPointerCarpeta.tarjetaFlotante) return

  sesionPointerCarpeta.tarjetaFlotante.style.left = `${event.clientX + 14}px`
  sesionPointerCarpeta.tarjetaFlotante.style.top = `${event.clientY + 14}px`
}

const crearTarjetaFlotante = (event) => {
  const tarjeta = document.createElement('div')
  const icono = document.createElement('span')
  const nombre = document.createElement('span')

  tarjeta.className = 'tree-folder-pointer-card'
  icono.className = 'mdi mdi-folder tree-folder-pointer-card__icon'
  icono.setAttribute('aria-hidden', 'true')
  nombre.className = 'tree-folder-pointer-card__name'
  nombre.textContent = sesionPointerCarpeta.origen.name

  tarjeta.append(icono, nombre)
  document.body.appendChild(tarjeta)
  sesionPointerCarpeta.tarjetaFlotante = tarjeta
  actualizarPosicionTarjeta(event)
}

const obtenerDestinoPointer = (event) => {
  const elemento = document.elementFromPoint(event.clientX, event.clientY)
  const fila = elemento?.closest?.('[data-folder-toc-id]')
  const origen = sesionPointerCarpeta.origen

  if (!fila || !origen || movingFolder.value) return null

  const tocId = Number(fila.dataset.folderTocId)
  if (
    !Number.isInteger(tocId) ||
    tocId <= 0 ||
    tocId === Number(origen.tocId) ||
    tocId === Number(origen.parentId) ||
    sesionPointerCarpeta.descendientesVisibles.includes(tocId)
  ) {
    return null
  }

  return {
    fila,
    tocId,
    name: fila.dataset.folderName || ''
  }
}

const quitarListenersPointer = () => {
  document.removeEventListener('pointermove', handleFolderPointerMove)
  document.removeEventListener('pointerup', handleFolderPointerUp)
  document.removeEventListener('pointercancel', handleFolderPointerCancel)
}

const limpiarSesionPointer = () => {
  quitarListenersPointer()
  actualizarDestinoActivo(null)
  sesionPointerCarpeta.tarjetaFlotante?.remove()
  sesionPointerCarpeta.tarjetaFlotante = null
  document.body?.classList.remove('tree-folder-pointer-dragging')
  isFolderDragging.value = false

  sesionPointerCarpeta.pointerId = null
  sesionPointerCarpeta.startX = 0
  sesionPointerCarpeta.startY = 0
  sesionPointerCarpeta.origen = null
  sesionPointerCarpeta.filaOrigen = null
  sesionPointerCarpeta.descendientesVisibles = []
  sesionPointerCarpeta.arrastreActivo = false
}

const confirmarMovimientoCarpeta = async (origen, destino) => {
  const confirmacion = await Swal.fire({
    title: '¿Mover carpeta?',
    html: `
      <div style="text-align: left;">
        <p><strong>Carpeta:</strong> ${origen.name}</p>
        <p><strong>Nuevo padre:</strong> ${destino.name}</p>
      </div>
    `,
    icon: 'question',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonText: 'Mover',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    customClass: {
      title: 'swal-title-custom',
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
    }
  })

  if (!confirmacion.isConfirmed || movingFolder.value) return

  emit('folder-move-requested', {
    tocId: origen.tocId,
    parentId: destino.tocId
  })
}

const handleFolderPointerMove = (event) => {
  if (event.pointerId !== sesionPointerCarpeta.pointerId) return

  const desplazamientoX = event.clientX - sesionPointerCarpeta.startX
  const desplazamientoY = event.clientY - sesionPointerCarpeta.startY

  if (!sesionPointerCarpeta.arrastreActivo) {
    if (Math.hypot(desplazamientoX, desplazamientoY) < UMBRAL_ARRASTRE_CARPETA) return

    sesionPointerCarpeta.arrastreActivo = true
    seleccionarCarpeta()
    isFolderDragging.value = true
    document.body.classList.add('tree-folder-pointer-dragging')
    crearTarjetaFlotante(event)
  }

  event.preventDefault()
  actualizarPosicionTarjeta(event)
  actualizarDestinoActivo(obtenerDestinoPointer(event)?.fila || null)
}

const finalizarPointerConArrastre = async (event) => {
  const origen = sesionPointerCarpeta.origen
  const destino = obtenerDestinoPointer(event)

  ignorarClickDespuesDrag.value = true
  limpiarSesionPointer()
  setTimeout(() => {
    ignorarClickDespuesDrag.value = false
  }, 0)

  if (!origen || !destino) return
  await confirmarMovimientoCarpeta(origen, destino)
}

const handleFolderPointerUp = (event) => {
  if (event.pointerId !== sesionPointerCarpeta.pointerId) return

  if (!sesionPointerCarpeta.arrastreActivo) {
    limpiarSesionPointer()
    return
  }

  void finalizarPointerConArrastre(event)
}

const handleFolderPointerCancel = (event) => {
  if (event.pointerId !== sesionPointerCarpeta.pointerId) return
  limpiarSesionPointer()
}

// eslint-disable-next-line no-unused-vars
const handleFolderPointerDown = (event) => {
  if (
    event.button !== 0 ||
    props.node.tipo !== 'c' ||
    movingFolder.value ||
    sesionPointerCarpeta.pointerId !== null
  ) {
    return
  }

  sesionPointerCarpeta.pointerId = event.pointerId
  sesionPointerCarpeta.startX = event.clientX
  sesionPointerCarpeta.startY = event.clientY
  sesionPointerCarpeta.origen = {
    tocId: props.node.tocId,
    parentId: props.node.parentId,
    name: props.node.name
  }
  sesionPointerCarpeta.filaOrigen = event.currentTarget
  sesionPointerCarpeta.descendientesVisibles = obtenerDescendientesVisibles(props.node)

  document.addEventListener('pointermove', handleFolderPointerMove)
  document.addEventListener('pointerup', handleFolderPointerUp)
  document.addEventListener('pointercancel', handleFolderPointerCancel)
}

const AccesoImportar = ref(false);
// 🚀 Descargas en segundo plano (autoejecutable)
const { procesarAutoejecutable, procesarExportar, procesarDescargaArchivo } = useDescargas();
// 📥 Importar en segundo plano
const { abrirConConfig: abrirImportar, pendingReloadTocId } = useImportarMinimizado()

// ── Variables del visor de documentos (Indexación de carpeta) ──
const urlVisorCarpeta     = ref('');
const cargandoVisorCarpeta = ref(false);
const errorVisorCarpeta   = ref('');
const esImagenVisorCarpeta = ref(false);
const docSeleccionadoVisor = ref(null);
const archivoNoVisualizableCarpeta = ref(false);
const plantillaVisorCarpeta = ref(null);

const pdfDocCarpeta       = shallowRef(null);
const totalPaginasCarpeta = ref(0);
const paginaActualCarpeta = ref(1);
const renderizandoCarpeta = ref(false);
const paginasRenderizadasCarpeta = ref(new Set());
const pdfScrollCarpeta    = ref(null);
const pdfPageRefsCarpeta  = ref({});
// PDF.js usa campos privados: las tareas deben conservarse sin Proxy de Vue.
const renderTasksCarpeta  = shallowRef({});



// Variables para indexación (agregar esta nueva)
const documentosSeleccionados = ref([]);

// Variables para el menú contextual
const showContextMenu = ref(false);
const menuX = ref(0);
const menuY = ref(0);
const contextNode = ref(null);

// Variables para asignar/quitar permisos
const dialogPermisos = ref(false);
const usuarios = ref([]);
const tiposPermiso = ref([]);
const usuarioSeleccionado = ref(null);
const permisoSeleccionado = ref(null);
const permisoActual = ref('---');
const cargandoPermisoActual = ref(false);

// Variables para generar índices
const dialogGenerarIndices = ref(false);
const columnas = ref([]);
const columnaSeleccionada = ref(null);
const cargandoColumnas = ref(false);
const templateIdEncontrado = ref(null); 


// Variables para indexación
const dialogIndexacion = ref(false);
const estructuraPlantilla = ref([]);
const valoresIndexacion = ref({});
const cargandoEstructura = ref(false);
const tabIndexacion = ref('no-indexados'); // 'no-indexados' o 'indexados'
const documentosNoIndexados = ref([]);
const documentosIndexados = ref([]);
const cargandoDocumentos = ref(false);

// ✅ Desindexación: selección con checks en el tab "Indexados"
const documentosIndexadosSeleccionados = ref([]);   // tocIds marcados para desindexar
const indiceFocusListaIndexados = ref(-1);
const modoSeleccionDesindexar = ref(false);         // se activa con Alt + X en el tab Indexados
const listaIndexadosRef = ref(null);
const virtualIndexadosRef = ref(null);


const esVideoVisorCarpeta = ref(false)
const esAudioVisorCarpeta = ref(false)
const mimeVisorCarpeta    = ref('')

const extensionesVideoVisor  = ['mp4', 'mkv', 'webm', 'mov', 'avi', 'm4v']
const extensionesAudioVisorC = ['mp3', 'wav', 'flac', 'm4a']

// ── Caché de documentos ya descargados ──
const visorCache = new Map()          // tocId → { url, esImagen, mime, tipo }
const MAX_CACHE = 5                   // máximo de documentos en caché
const PREFETCH_EN_DIRECCION = 2
const PREFETCH_EN_CONTRA = 1
const MAX_PREFETCH_SIMULTANEOS = 2
const DEBUG_PREFETCH_VISOR = false
const DELAY_DOCUMENTO_NO_CACHEADO = 300
const abortControllerVisor = ref(null) // AbortController de la descarga activa
const cargaIdActual = ref(0)          // ID incremental para descartes de cargas viejas
const prefetchVisorEnCurso = new Map()
const prefetchVisorControllers = new Map()
let idsVentanaVisor = new Set()
let indiceAnteriorVisor = null
let plantillaVentanaVisor = null
let candidatosPrefetchVisor = []
let documentoPendienteVisor = null
let aperturaVisorTimeout = null
let navegandoVisor = false
const extensionesImagenPrefetchVisor = ['jpg', 'jpeg', 'png', 'webp']

// ── Debounce de navegación: al mantener presionada una flecha, el foco y el
//    resaltado se mueven al instante pero el visor solo carga el documento
//    donde el usuario se detiene (evita una ráfaga de descargas abortadas) ──
let visorNavTimeout = null
// eslint-disable-next-line no-unused-vars -- se conserva para compatibilidad con la navegación existente
const cargarVisorCarpetaDebounced = (tocId, plantillaId) => {
  if (visorNavTimeout) clearTimeout(visorNavTimeout)
  visorNavTimeout = setTimeout(() => {
    visorNavTimeout = null
    cargarVisorCarpeta(tocId, plantillaId)
  }, 130)
}

// ── Cargar documento en el visor de carpeta ──
const cargarVisorCarpeta = async (tocId, plantillaId) => {
  // ── 1. Incrementar ID de carga — cualquier carga previa queda "obsoleta" ──
  const miCargaId = ++cargaIdActual.value
  archivoNoVisualizableCarpeta.value = false
  plantillaVisorCarpeta.value = plantillaId

  const nombreArchivo = docSeleccionadoVisor.value?.nameToc || ''
  const ext = nombreArchivo.split('.').pop().toLowerCase()

  // ── 2. Cancelar descarga HTTP anterior si sigue en curso ──
  if (abortControllerVisor.value) {
    abortControllerVisor.value.abort()
    abortControllerVisor.value = null
  }

  // ── 3. Cancelar renders PDF anteriores ──
  const tareasActivas = Object.values(renderTasksCarpeta.value)
  for (const task of tareasActivas) {
    try { if (task?.cancel) task.cancel() } catch (e) { void e }
  }
  renderTasksCarpeta.value = {}
  paginasRenderizadasCarpeta.value = new Set()
  pdfPageRefsCarpeta.value = {}

  if (ext === 'doc' || ext === 'docx') {
    urlVisorCarpeta.value = ''
    cargandoVisorCarpeta.value = false
    errorVisorCarpeta.value = ''
    esImagenVisorCarpeta.value = false
    esVideoVisorCarpeta.value = false
    esAudioVisorCarpeta.value = false
    mimeVisorCarpeta.value = ''
    pdfDocCarpeta.value = null
    archivoNoVisualizableCarpeta.value = true
    return
  }

  // ── 4. Revisar caché antes de descargar ──
  if (visorCache.has(tocId)) {
    const cached = visorCache.get(tocId)

    // ✅ LRU: re-insertar al final para que los documentos más usados
    //    no sean desalojados antes que los que nunca se revisitan
    visorCache.delete(tocId)
    visorCache.set(tocId, cached)

    // Verificar que el blob URL sigue vivo (puede haber sido revocado)
    urlVisorCarpeta.value     = cached.url
    esImagenVisorCarpeta.value = cached.esImagen
    esVideoVisorCarpeta.value  = cached.esVideo
    esAudioVisorCarpeta.value  = cached.esAudio
    mimeVisorCarpeta.value     = cached.mime
    errorVisorCarpeta.value    = ''
    cargandoVisorCarpeta.value = false

    // Si es PDF: reutilizar el pdfDoc ya parseado si existe — solo re-renderiza
    if (!cached.esImagen && !cached.esVideo && !cached.esAudio) {
      pdfDocCarpeta.value = null
      await nextTick()
      await nextTick()
      await renderizarPdfCarpeta(cached.url, { pdfDoc: cached.pdfDoc, tocId })
    }
    if (DEBUG_PREFETCH_VISOR) console.log('Visor servido desde caché:', tocId)
    setTimeout(() => {
      actualizarVentanaCacheVisor(tocId, plantillaId)
    }, 0)
    return
  }

  // ── 5. No está en caché — iniciar descarga ──
  zoomLevel.value = 1
  cargandoVisorCarpeta.value = true
  errorVisorCarpeta.value    = ''
  esImagenVisorCarpeta.value = false
  esVideoVisorCarpeta.value  = false
  esAudioVisorCarpeta.value  = false
  mimeVisorCarpeta.value     = ''
  pdfDocCarpeta.value        = null

  const token = localStorage.getItem('token')
  const idUsuarioSesion = localStorage.getItem('idUsuario')

  // ZIP / RAR — sin visor
  if (ext === 'zip' || ext === 'rar') {
    if (miCargaId !== cargaIdActual.value) return
    cargandoVisorCarpeta.value = false
    errorVisorCarpeta.value = 'Vista previa no disponible para archivos ZIP o RAR'
    return
  }

  // Video — streaming directo, sin descarga ni caché
  if (extensionesVideoVisor.includes(ext)) {
    if (miCargaId !== cargaIdActual.value) return
    mimeVisorCarpeta.value = `video/${ext === 'mkv' ? 'x-matroska' : ext === 'm4v' ? 'mp4' : ext === 'mov' ? 'quicktime' : ext}`
    urlVisorCarpeta.value = buildApiUrl(
      `/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}?token=${encodeURIComponent(token)}`
    )
    esVideoVisorCarpeta.value = true
    cargandoVisorCarpeta.value = false
    return
  }

  // Audio — streaming directo, sin descarga ni caché
  if (extensionesAudioVisorC.includes(ext)) {
    if (miCargaId !== cargaIdActual.value) return
    mimeVisorCarpeta.value = `audio/${ext === 'm4a' ? 'mp4' : ext === 'flac' ? 'flac' : ext}`
    urlVisorCarpeta.value = buildApiUrl(
      `/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}?token=${encodeURIComponent(token)}`
    )
    esAudioVisorCarpeta.value = true
    cargandoVisorCarpeta.value = false
    return
  }

  // PDF / Imagen / TIFF — descargar con AbortController
  try {
    const controller = new AbortController()
    abortControllerVisor.value = controller

    const response = await axios.get(
      buildApiUrl(`/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}`),
      {
        responseType: 'blob',
        signal: controller.signal   // ← axios respeta AbortController desde v0.22
      }
    )

    // ── Descartar si ya llegó una carga más nueva ──
    if (miCargaId !== cargaIdActual.value) return

    abortControllerVisor.value = null
    const contentType = response.headers['content-type'] || 'application/pdf'
    const esTiff = contentType === 'image/tiff' || contentType === 'image/tif'
                   || ext === 'tif' || ext === 'tiff'

    let blobUrl = ''
    let esImagen = false

    if (esTiff) {
      const buffer = await response.data.arrayBuffer()
      if (miCargaId !== cargaIdActual.value) return  // chequeo tras operación pesada
      const ifds = UTIF.decode(buffer)
      UTIF.decodeImage(buffer, ifds[0])
      const rgba = UTIF.toRGBA8(ifds[0])
      const w = ifds[0].width, h = ifds[0].height
      const canvas = document.createElement('canvas')
      canvas.width = w; canvas.height = h
      const ctx = canvas.getContext('2d')
      const imageData = ctx.createImageData(w, h)
      imageData.data.set(new Uint8Array(rgba))
      ctx.putImageData(imageData, 0, 0)
      blobUrl  = canvas.toDataURL('image/png')
      esImagen = true
    } else {
      const blob = new Blob([response.data], { type: contentType })
      blobUrl  = URL.createObjectURL(blob)
      esImagen = contentType.startsWith('image/')
    }

    if (miCargaId !== cargaIdActual.value) {
      // Llegó tarde — liberar blob y salir sin tocar el visor
      if (blobUrl.startsWith('blob:')) URL.revokeObjectURL(blobUrl)
      return
    }

    // ── Guardar en caché ──
    agregarAlCache(tocId, {
      url:     blobUrl,
      esImagen,
      esVideo: false,
      esAudio: false,
      mime:    contentType
    })

    // ── Mostrar en el visor ──
    urlVisorCarpeta.value      = blobUrl
    esImagenVisorCarpeta.value = esImagen
    cargandoVisorCarpeta.value = false

    if (!esImagen) {
      await nextTick()
      await nextTick()
      await renderizarPdfCarpeta(blobUrl, { tocId })
    }

    setTimeout(() => {
      actualizarVentanaCacheVisor(tocId, plantillaId)
    }, 0)

  } catch (error) {
    if (error.name === 'CanceledError' || error.name === 'AbortError') return
    if (miCargaId !== cargaIdActual.value) return
    cargandoVisorCarpeta.value = false
    errorVisorCarpeta.value = 'No se pudo cargar el documento'
  }
}

const descargarDocumentoWordCarpeta = () => {
  const documento = docSeleccionadoVisor.value
  if (!documento) return

  const idUsuarioSesion = localStorage.getItem('idUsuario')
  procesarDescargaArchivo({
    url: `/api/Indexacion/ver-documento/${documento.tocId}/${idUsuarioSesion}/${plantillaVisorCarpeta.value}`,
    nombre: documento.nameToc
  })
}

// Liberar los recursos de una entrada del caché (blob URL + pdfDoc parseado)
const liberarEntradaCache = (entrada) => {
  if (entrada?.url?.startsWith('blob:')) {
    URL.revokeObjectURL(entrada.url)
  }
  // No destruir el pdfDoc si es el que está mostrándose en el visor
  if (entrada?.pdfDoc && entrada.pdfDoc !== pdfDocCarpeta.value) {
    try { entrada.pdfDoc.destroy() } catch (e) { void e }
  }
}

const agregarAlCache = (tocId, entrada) => {
  // Si ya está, no duplicar
  if (visorCache.has(tocId)) return false

  // Si el caché está lleno, eliminar la entrada menos usada (LRU)
  if (visorCache.size >= MAX_CACHE) {
    const primeraKey = [...visorCache.keys()].find(id => !idsVentanaVisor.has(id))
    if (primeraKey == null) return false
    liberarEntradaCache(visorCache.get(primeraKey))
    visorCache.delete(primeraKey)
    if (DEBUG_PREFETCH_VISOR) console.log('Visor eliminado del caché:', primeraKey)
  }

  visorCache.set(tocId, entrada)
  if (DEBUG_PREFETCH_VISOR) console.log('Tamaño actual de visorCache:', visorCache.size)
  return true
}

const esImagenPrecargableVisor = (doc) => {
  const nombre = doc?.nameToc || ''
  const extension = nombre.split('.').pop()?.toLowerCase()
  return extensionesImagenPrefetchVisor.includes(extension)
}

const programarPrefetchVisor = () => {
  if (navegandoVisor) return
  while (prefetchVisorEnCurso.size < MAX_PREFETCH_SIMULTANEOS) {
    const doc = candidatosPrefetchVisor.find(candidato => (
      idsVentanaVisor.has(candidato.tocId) &&
      !visorCache.has(candidato.tocId) &&
      !prefetchVisorEnCurso.has(candidato.tocId)
    ))
    if (!doc) break
    precargarImagenVisor(doc, plantillaVentanaVisor)
  }
}

const precargarImagenVisor = async (doc, plantillaId) => {
  const tocId = doc?.tocId
  if (!tocId || !plantillaId || !esImagenPrecargableVisor(doc) ||
      visorCache.has(tocId) || prefetchVisorEnCurso.has(tocId) ||
      !idsVentanaVisor.has(tocId)) return
  const idUsuarioSesion = localStorage.getItem('idUsuario');

  const controller = new AbortController()
  prefetchVisorControllers.set(tocId, controller)
  const solicitud = (async () => {
    try {
      if (DEBUG_PREFETCH_VISOR) console.log('Visor solicitado por precarga:', tocId)
      const response = await axios.get(
        buildApiUrl(`/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}`),
        { responseType: 'blob', signal: controller.signal }
      )
      const contentType = (response.headers['content-type'] || '').toLowerCase()
      if (!contentType.startsWith('image/') || !idsVentanaVisor.has(tocId)) return

      const url = URL.createObjectURL(response.data)
      if (!idsVentanaVisor.has(tocId) || visorCache.has(tocId)) {
        URL.revokeObjectURL(url)
        return
      }
      const agregado = agregarAlCache(tocId, {
        url,
        esImagen: true,
        esVideo: false,
        esAudio: false,
        mime: contentType,
        prefetched: true
      })
      if (!agregado) URL.revokeObjectURL(url)
    } catch (error) {
      if ((error.name === 'CanceledError' || error.name === 'AbortError') && DEBUG_PREFETCH_VISOR) {
        console.log('Visor cuya precarga fue cancelada:', tocId)
      }
    } finally {
      prefetchVisorEnCurso.delete(tocId)
      prefetchVisorControllers.delete(tocId)
      programarPrefetchVisor()
    }
  })()
  prefetchVisorEnCurso.set(tocId, solicitud)
}

const actualizarVentanaCacheVisor = (tocIdActual, plantillaId) => {
  if (navegandoVisor) return
  const documentos = tabIndexacion.value === 'indexados'
    ? documentosIndexados.value
    : documentosNoIndexados.value
  const indiceActual = documentos.findIndex(doc => doc.tocId === tocIdActual)
  if (indiceActual < 0) return

  const direccion = indiceAnteriorVisor == null || indiceActual >= indiceAnteriorVisor ? 1 : -1
  indiceAnteriorVisor = indiceActual
  plantillaVentanaVisor = plantillaId

  const vecinosEnDireccion = Array.from(
    { length: PREFETCH_EN_DIRECCION },
    (_, indice) => documentos[indiceActual + direccion * (indice + 1)]
  ).filter(Boolean)
  const vecinosEnContra = Array.from(
    { length: PREFETCH_EN_CONTRA },
    (_, indice) => documentos[indiceActual - direccion * (indice + 1)]
  ).filter(Boolean)
  const ventana = [documentos[indiceActual], ...vecinosEnContra, ...vecinosEnDireccion]
  idsVentanaVisor = new Set(ventana.map(doc => doc.tocId))

  prefetchVisorControllers.forEach((controller, id) => {
    if (!idsVentanaVisor.has(id)) controller.abort()
  })
  visorCache.forEach((entrada, id) => {
    if (id !== tocIdActual && !idsVentanaVisor.has(id)) {
      liberarEntradaCache(entrada)
      visorCache.delete(id)
      if (DEBUG_PREFETCH_VISOR) console.log('Visor eliminado del caché:', id)
    }
  })
  if (DEBUG_PREFETCH_VISOR) console.log('Tamaño actual de visorCache:', visorCache.size)

  candidatosPrefetchVisor = [...vecinosEnDireccion, ...vecinosEnContra]
    .filter(esImagenPrecargableVisor)
  programarPrefetchVisor()
}

const estiloMarcoPaginaCarpeta = (n) => {
  const dimensiones = dimsBasePaginasCarpeta.value[n] || dimsBasePaginasCarpeta.value[1]
  if (!dimensiones) return { position: 'relative', display: 'inline-block', verticalAlign: 'top' }
  return {
    position: 'relative', display: 'inline-block', verticalAlign: 'top', overflow: 'hidden',
    width: `${dimensiones.w * zoomEfectivoCarpeta.value}px`,
    height: `${dimensiones.h * zoomEfectivoCarpeta.value}px`
  }
}

const estiloTextLayerPaginaCarpeta = (n) => {
 //cambios para la mejora de velocidad del visor de PDF, evitando renderizados innecesarios mientras el usuario ajusta el nivel de zoom.
  const zr = zoomTextLayerCarpeta.value[n] || 1 // antes: zoomRender PaginaCarpeta

  return { // El textLayer se construye a escala 1:1 y luego se escala con CSS para que coincida con el canvas.
    transform: `scale(${zoomEfectivoCarpeta.value / zr})`,
    transformOrigin: '0 0'
  }
}

const cancelarRendersPdfCarpeta = async () => {
  const tareas = Object.values(renderTasksCarpeta.value)
  tareas.forEach(task => { try { task?.cancel?.() } catch (e) { void e } })
  await Promise.allSettled(tareas.map(task => task?.promise || Promise.resolve()))
  renderTasksCarpeta.value = {}
}

const limpiarPaginasPdfFueraVentana = (paginaCentral) => {
  const radio = Math.floor((MAX_PAGINAS_PDF_RENDERIZADAS - 1) / 2)
  const permitidas = new Set()
  for (let n = Math.max(1, paginaCentral - radio); n <= Math.min(totalPaginasCarpeta.value, paginaCentral + radio); n++) permitidas.add(n)
  paginasRenderizadasCarpeta.value.forEach(n => {
    if (permitidas.has(n) || renderTasksCarpeta.value[n]) return
    const canvas = document.getElementById(`visor-carpeta-canvas-${n}`)
    const textLayer = document.getElementById(`visor-carpeta-textlayer-${n}`)
    if (canvas) { canvas.width = 0; canvas.height = 0 }
    if (textLayer) textLayer.innerHTML = ''
    paginasRenderizadasCarpeta.value.delete(n)
    delete canvasHeights.value[n]
    delete zoomTextLayerCarpeta.value[n] //limpieza el zoom del text layer para que se renderice nuevamente al cambiar el zoom
  })
}

const renderizarPdfCarpeta = async (url, opts = {}) => {
  await limpiarEstadoPdfCarpeta()
  let pdf = opts.pdfDoc
  if (!pdf) {
    const loadingTask = pdfjsLib.getDocument(url)
    pdf = await loadingTask.promise
    if (opts.tocId != null && visorCache.has(opts.tocId)) visorCache.get(opts.tocId).pdfDoc = pdf
  }
  pdfDocCarpeta.value = pdf
  totalPaginasCarpeta.value = pdf.numPages
  paginaActualCarpeta.value = 1
  zoomLevel.value = 1
  paginasRenderizadasCarpeta.value = new Set()
  pdfPageRefsCarpeta.value = {}
  zoomRenderPaginaCarpeta.value = {}
  zoomTextLayerCarpeta.value = {} //limpieza el zoom del text layer para que se renderice nuevamente al cambiar el zoom
  textContentCacheCarpeta.value = {}
  canvasHeights.value = {}

  const paginaUno = await pdf.getPage(1)
  const original = paginaUno.getViewport({ scale: 1 })
  const escalaBase = ((pdfScrollCarpeta.value?.clientWidth || 800) - 24) / original.width
  const dimensionesEstimadas = {}
  for (let n = 1; n <= pdf.numPages; n++) {
    dimensionesEstimadas[n] = { w: original.width * escalaBase, h: original.height * escalaBase }
  }
  dimsBasePaginasCarpeta.value = dimensionesEstimadas

  await nextTick()
  await nextTick()
  await renderizarPaginaPdfCarpeta(1)
  ;(async () => {
    for (let n = 2; n <= Math.min(pdf.numPages, 3); n++) {
      if (pdfDocCarpeta.value !== pdf) return
      await renderizarPaginaPdfCarpeta(n)
    }
  })()
}

const renderizarPaginaPdfCarpeta = async (n) => {
  if (!pdfDocCarpeta.value || paginasRenderizadasCarpeta.value.has(n) || renderTasksCarpeta.value[n]) return
  const pdfAlIniciar = pdfDocCarpeta.value
  const zoomAlIniciar = zoomEfectivoCarpeta.value
  renderizandoCarpeta.value = true
  let renderTask = null
  try {
    const page = await pdfAlIniciar.getPage(n)
    if (pdfDocCarpeta.value !== pdfAlIniciar) return
    const canvas = document.getElementById(`visor-carpeta-canvas-${n}`)
    if (!canvas) return
    const original = page.getViewport({ scale: 1 })
    const escalaBase = ((pdfScrollCarpeta.value?.clientWidth || 800) - 24) / original.width
    dimsBasePaginasCarpeta.value[n] = { w: original.width * escalaBase, h: original.height * escalaBase }
    const viewport = page.getViewport({ scale: escalaBase * zoomAlIniciar })
    const canvasTmp = document.createElement('canvas')
    canvasTmp.width = viewport.width
    canvasTmp.height = viewport.height
    const ctxTmp = canvasTmp.getContext('2d')
    renderTask = page.render({ canvasContext: ctxTmp, viewport })
    renderTasksCarpeta.value[n] = renderTask
    await renderTask.promise
    if (pdfDocCarpeta.value !== pdfAlIniciar || zoomEfectivoCarpeta.value !== zoomAlIniciar) return


   //apartir de aqui hasta

    canvas.width = viewport.width
    canvas.height = viewport.height
    canvas.getContext('2d').drawImage(canvasTmp, 0, 0)
    zoomRenderPaginaCarpeta.value[n] = zoomAlIniciar

    const textLayer = document.getElementById(`visor-carpeta-textlayer-${n}`)
    const zrTL = zoomTextLayerCarpeta.value[n] 
    const necesitaTextLayer = !zrTL || (zoomAlIniciar / zrTL > 2 || (zoomAlIniciar / zrTL) < 0.5)

    if (textLayer && necesitaTextLayer) { //vamos agregar una nueva condicion que es de necesitar el texto layer solo si el zoom es mayor a 2 o menor a 0.5 veces el zoom anterior, para mejorar la velocidad del visor de PDF
      textLayer.innerHTML = ''
      textLayer.style.width = `${viewport.width}px`
      textLayer.style.height = `${viewport.height}px`
      let textContent = textContentCacheCarpeta.value[n]
      if (!textContent) {
        textContent = await page.getTextContent()
        textContentCacheCarpeta.value[n] = textContent
      }
      const textDivs = []
      await pdfjsLib.renderTextLayer({ textContent, container: textLayer, viewport, textDivs }).promise
      textContent.items.forEach((item, index) => {
        const div = textDivs[index]
        if (!div || !item.str?.trim() || !item.width || (div.style.transform || '').includes('rotate')) return
        if (div.offsetWidth > 0) div.style.transform = `scaleX(${(item.width * viewport.scale) / div.offsetWidth})`
      })
      const endOfContent = document.createElement('div')
      endOfContent.className = 'endOfContent'
      textLayer.appendChild(endOfContent)
      textLayer.onmousedown = () => endOfContent.classList.add('active')
      textLayer.onmouseup = () => endOfContent.classList.remove('active')

      zoomTextLayerCarpeta.value[n] = zoomAlIniciar  //codigo agregado para mejorar la velocidad del visor de PDF, evitando renderizados innecesarios mientras el usuario ajusta el nivel de zoom.

    }
    paginasRenderizadasCarpeta.value.add(n)




    canvasHeights.value[n] = canvas.height
    limpiarPaginasPdfFueraVentana(paginaActualCarpeta.value)
  } catch (e) {
    if (e?.name !== 'RenderingCancelledException') console.error(e)
  } finally {
    if (renderTasksCarpeta.value[n] === renderTask) delete renderTasksCarpeta.value[n]
    renderizandoCarpeta.value = Object.keys(renderTasksCarpeta.value).length > 0
  }
}

const reRenderizarPdfCarpetaPorZoom = async (zoomSolicitado) => {
  const pdf = pdfDocCarpeta.value
  if (!pdf || zoomEfectivoCarpeta.value !== zoomSolicitado) return
  await cancelarRendersPdfCarpeta()
  if (pdfDocCarpeta.value !== pdf || zoomEfectivoCarpeta.value !== zoomSolicitado) return
  paginasRenderizadasCarpeta.value = new Set()
  const actual = paginaActualCarpeta.value
  await renderizarPaginaPdfCarpeta(actual)
  for (let n = Math.max(1, actual - 2); n <= Math.min(totalPaginasCarpeta.value, actual + 2); n++) {
    if (n === actual || pdfDocCarpeta.value !== pdf || zoomEfectivoCarpeta.value !== zoomSolicitado) continue
    await renderizarPaginaPdfCarpeta(n)
  }
  limpiarPaginasPdfFueraVentana(actual)
  if(zoomEfectivoCarpeta.value === zoomSolicitado) zoomEnCursoCarpeta.value = false //cambios aplicados para aumentar la velocidad del zoom 
}

const limpiarEstadoPdfCarpeta = async ({ destruirDocumento = false } = {}) => {
  if (zoomWatchTimeout) {
    clearTimeout(zoomWatchTimeout)
    zoomWatchTimeout = null
  }
  await cancelarRendersPdfCarpeta()
  for (let n = 1; n <= totalPaginasCarpeta.value; n++) {
    const canvas = document.getElementById(`visor-carpeta-canvas-${n}`)
    const textLayer = document.getElementById(`visor-carpeta-textlayer-${n}`)
    if (canvas) { canvas.width = 0; canvas.height = 0 }
    if (textLayer) textLayer.innerHTML = ''
  }
  zoomTextLayerCarpeta.value = {} //limpieza el zoom del text layer para que se renderice nuevamente al cambiar el zoom
  const contenedor = pdfScrollCarpeta.value || imagenScrollCarpeta.value
  if (pointerIdArrastreCarpeta != null && contenedor?.hasPointerCapture?.(pointerIdArrastreCarpeta)) {
    contenedor.releasePointerCapture(pointerIdArrastreCarpeta)
  }
  pointerIdArrastreCarpeta = null
  isDraggingCarpeta.value = false
  if (destruirDocumento) {
    try { await pdfDocCarpeta.value?.destroy?.() } catch (e) { void e }
  }
  pdfDocCarpeta.value = null
  paginasRenderizadasCarpeta.value = new Set()
  dimsBasePaginasCarpeta.value = {}
  zoomRenderPaginaCarpeta.value = {}
  textContentCacheCarpeta.value = {}
  pdfPageRefsCarpeta.value = {}
  canvasHeights.value = {}
  totalPaginasCarpeta.value = 0
  paginaActualCarpeta.value = 1
  zoomLevel.value = 1
}

const onScrollVisorCarpeta = () => {
  const container = pdfScrollCarpeta.value;
  if (!container) return;
  const scrollCenter = container.scrollTop + container.clientHeight / 2;
  let mejor = 1, mejorDist = Infinity;
  for (let n = 1; n <= totalPaginasCarpeta.value; n++) {
    const el = pdfPageRefsCarpeta.value[n];
    if (!el) continue;
    const dist = Math.abs(scrollCenter - (el.offsetTop + el.offsetHeight / 2));
    if (dist < mejorDist) { mejorDist = dist; mejor = n; }
  }
  paginaActualCarpeta.value = mejor;
  if (zoomEnCursoCarpeta.value) return; // Evitar renderizar mientras se hace zoom
  const buffer = 2;
  for (let i = Math.max(1, mejor - buffer); i <= Math.min(totalPaginasCarpeta.value, mejor + buffer); i++) {
    if (!paginasRenderizadasCarpeta.value.has(i) && !renderTasksCarpeta.value[i]) renderizarPaginaPdfCarpeta(i);
  }
  limpiarPaginasPdfFueraVentana(mejor)
};

const irAPaginaCarpeta = async (n) => {
  if (n < 1 || n > totalPaginasCarpeta.value) return;
  if (!paginasRenderizadasCarpeta.value.has(n)) {
    await renderizarPaginaPdfCarpeta(n);
    await nextTick();
  }
  const el = pdfPageRefsCarpeta.value[n];
  if (el) { paginaActualCarpeta.value = n; el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
};


// ── Variables para navegación por teclado en el listado ──
const listaDocumentosRef = ref(null);
const virtualNoIndexadosRef = ref(null);
const indiceFocusLista = ref(-1);

const enfocarListaNoIndexados = () => {
  requestAnimationFrame(() => {
    listaDocumentosRef.value?.focus({ preventScroll: true })
  })
}

const enfocarListaDesdeModal = () => {
  if (!dialogIndexacion.value || tabIndexacion.value !== 'no-indexados') return
  nextTick(() => {
    listaDocumentosRef.value?.focus({ preventScroll: true })
  })
}

const enfocarListaIndexados = () => {
  requestAnimationFrame(() => {
    listaIndexadosRef.value?.focus({ preventScroll: true })
  })
}

const pausarSolicitudesVisorDuranteNavegacion = (tocIdConservar = null) => {
  navegandoVisor = true
  if (visorNavTimeout) {
    clearTimeout(visorNavTimeout)
    visorNavTimeout = null
  }
  if (abortControllerVisor.value) {
    abortControllerVisor.value.abort()
    abortControllerVisor.value = null
    cargaIdActual.value++
    cargandoVisorCarpeta.value = false
    if (DEBUG_PREFETCH_VISOR) console.log('Solicitud visible cancelada')
  }
  prefetchVisorControllers.forEach((controller, tocId) => {
    if (tocId !== tocIdConservar) {
      controller.abort()
      if (DEBUG_PREFETCH_VISOR) console.log('PREFETCH_CANCELADO:', tocId)
    }
  })
}

const confirmarAperturaVisor = (pendiente) => {
  const { doc, index, plantillaId, tab } = pendiente
  const documentosActivos = tab === 'indexados'
    ? documentosIndexados.value
    : documentosNoIndexados.value
  if (documentoPendienteVisor !== pendiente || tabIndexacion.value !== tab ||
      documentosActivos[index]?.tocId !== doc.tocId) return false

  documentoPendienteVisor = null
  navegandoVisor = false
  docSeleccionadoVisor.value = doc
  if (DEBUG_PREFETCH_VISOR) console.log('SOLICITUD_VISIBLE_INICIADA:', doc.tocId)
  cargarVisorCarpeta(doc.tocId, plantillaId)
  return true
}

const programarAperturaVisor = (doc, index, plantillaId, tab) => {
  if (!doc || !plantillaId) return
  if (aperturaVisorTimeout) clearTimeout(aperturaVisorTimeout)

  const pendiente = { doc, index, plantillaId, tab }
  documentoPendienteVisor = pendiente
  if (DEBUG_PREFETCH_VISOR) console.log('Documento enfocado provisionalmente:', doc.tocId)

  if (visorCache.has(doc.tocId)) {
    pausarSolicitudesVisorDuranteNavegacion(doc.tocId)
    if (DEBUG_PREFETCH_VISOR) console.log('CACHE_HIT_INMEDIATO:', doc.tocId)
    confirmarAperturaVisor(pendiente)
    return
  }

  const prefetchPendiente = prefetchVisorEnCurso.get(doc.tocId)
  if (prefetchPendiente) {
    pausarSolicitudesVisorDuranteNavegacion(doc.tocId)
    if (DEBUG_PREFETCH_VISOR) console.log('PREFETCH_PROMOVIDO:', doc.tocId)
    prefetchPendiente.then(() => {
      if (visorCache.has(doc.tocId)) confirmarAperturaVisor(pendiente)
      else if (documentoPendienteVisor === pendiente) {
        documentoPendienteVisor = null
        navegandoVisor = false
      }
    })
    return
  }

  pausarSolicitudesVisorDuranteNavegacion(doc.tocId)
  if (DEBUG_PREFETCH_VISOR) console.log('SOLICITUD_NUEVA_PROGRAMADA:', doc.tocId)
  aperturaVisorTimeout = setTimeout(() => {
    aperturaVisorTimeout = null
    confirmarAperturaVisor(pendiente)
  }, DELAY_DOCUMENTO_NO_CACHEADO)
}


const actualizarVisorDocumentoEnfocado = () => {
  const index = indiceFocusLista.value
  const doc = documentosNoIndexados.value[index]
  if (!doc) return
  programarAperturaVisor(doc, index, obtenerTemplateIdVisor(), 'no-indexados')
}

const seleccionarRangoDesdeAncla = () => {
  if (indiceAnclaSeleccion.value < 0 || indiceFocusLista.value < 0) return
  const inicio = Math.min(indiceAnclaSeleccion.value, indiceFocusLista.value)
  const fin = Math.max(indiceAnclaSeleccion.value, indiceFocusLista.value)
  const idsRango = documentosNoIndexados.value.slice(inicio, fin + 1).map(doc => doc.tocId)
  documentosSeleccionados.value = idsRango
}

const moverFocoLista = (nuevoIndice, extender = false) => {
  const total = documentosNoIndexados.value.length
  if (total === 0) return
  const indiceAnterior = indiceFocusLista.value < 0 ? 0 : indiceFocusLista.value
  if (extender && indiceAnclaSeleccion.value < 0) indiceAnclaSeleccion.value = indiceAnterior
  indiceFocusLista.value = Math.max(0, Math.min(nuevoIndice, total - 1))
  scrollItemVisible(indiceFocusLista.value)
  actualizarVisorDocumentoEnfocado()
  if (extender) seleccionarRangoDesdeAncla()
  else indiceAnclaSeleccion.value = indiceFocusLista.value
}

const handleKeyMetadata = (event) => {
  if (event.key !== 'Enter') return
  const select = event.currentTarget?.closest?.('.v-select')
  const menuAbierto = select?.getAttribute('aria-expanded') === 'true' ||
    document.querySelector('.v-overlay--active .v-list-item--active')
  if (menuAbierto) return
  event.preventDefault()
  enfocarListaDesdeModal()
}

// Navegación por teclado en la lista de documentos

	const handleKeyListado = (event) => {
  const total = documentosNoIndexados.value.length
  if (total === 0) return

  if (event.key === 'ArrowDown') {
    event.preventDefault()
    moverFocoLista(indiceFocusLista.value < 0 ? 0 : indiceFocusLista.value + 1, event.shiftKey)
  } else if (event.key === 'ArrowUp') {
    event.preventDefault()
    moverFocoLista(indiceFocusLista.value < 0 ? total - 1 : indiceFocusLista.value - 1, event.shiftKey)
  } else if (event.key === 'Home' || event.key === 'End') {
    event.preventDefault()
    moverFocoLista(event.key === 'Home' ? 0 : total - 1, event.shiftKey)
  } else if (event.key === ' ') {
    event.preventDefault()
    if (indiceFocusLista.value >= 0) {
      toggleDocumento(documentosNoIndexados.value[indiceFocusLista.value].tocId)
      indiceAnclaSeleccion.value = indiceFocusLista.value
    }
  } else if (event.key === 'Enter') {
    event.preventDefault()
    guardarIndexacion()
  } else if (event.key === 'Tab') {
    event.preventDefault()
    indiceFocusBotones.value = 0
    nextTick(() => btnGuardarRef.value?.$el?.focus())

  } else if (event.key === 'Delete') {
    event.preventDefault()
    // Solo elimina si hay un documento sombreado con la flecha
    if (indiceFocusLista.value >= 0) {
      const doc = documentosNoIndexados.value[indiceFocusLista.value]
      if (doc) eliminarDocumentoConFoco(doc)
    }
  }
}


// Mantener el ítem enfocado visible dentro del scroll
const scrollItemVisible = (index) => {
  virtualNoIndexadosRef.value?.scrollToIndex(index)
  enfocarListaNoIndexados()
}



const eliminarDocumentoConFoco = async (doc) => {
  const result = await Swal.fire({
    title: '¿Está seguro?',
    html: `¿Desea eliminar el documento:<br><strong>${doc.nameToc}</strong>?`,
    icon: 'warning',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    focusConfirm: true,
    allowEnterKey: true,
    keydownListenerCapture: true,
    customClass: {
      title: 'swal-title-custom',
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
    },
    didOpen: () => {
      Swal.getConfirmButton()?.focus()
    }
  })

  if (!result.isConfirmed) return

  let templateId = templateIdEncontrado.value || contextNode.value.templateId
  if (!templateId || templateId === 0) {
    const hijo = contextNode.value.children?.find(c => c.templateId > 0)
    if (hijo) templateId = hijo.templateId
  }
  if (!templateId || templateId === 0) templateId = props.templateId

  const idUsuarioSesion = localStorage.getItem('idUsuario')

  Swal.fire({
    title: 'Eliminando...',
    allowOutsideClick: false,
    customClass: { title: 'swal-title-custom', loader: 'swal-loader-custom', container: 'swal-sobre-modal' },
    didOpen: () => Swal.showLoading()
  })

  try {
    const res = await axios.delete(
      buildApiUrl(`/api/Doc/eliminar-documento/${doc.tocId}?plantillaId=${templateId}&idUsuarioSesion=${idUsuarioSesion}`)
    )

    Swal.close()

    if (res.data.success) {
      await Swal.fire({
        icon: 'success', iconColor: '#ce501b', title: '¡Eliminado!',
        html: `<strong>${doc.nameToc}</strong> fue eliminado correctamente`,
        timer: 2000, showConfirmButton: false,
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      })

      // Ajustar foco después de eliminar
      indiceAnclaSeleccion.value = -1
      indiceFocusLista.value = -1
      documentosSeleccionados.value = documentosSeleccionados.value.filter(id => id !== doc.tocId)

      // Recargar listas
      const tplId = templateIdEncontrado.value || contextNode.value.templateId || props.templateId
      cargandoDocumentos.value = true
      await Promise.all([
        obtenerArchivosNoIndexados(contextNode.value.tocId, tplId),
        obtenerArchivosIndexados(contextNode.value.tocId, tplId)
      ])
      cargandoDocumentos.value = false
      emit('reload-subcarpetas', contextNode.value.tocId)
      emit('folder-selected', contextNode.value)

    } else {
      Swal.fire({
        icon: 'error', iconColor: '#ce501b', title: 'Error',
        text: res.data.mensaje || 'No se pudo eliminar el documento',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      })
    }
  } catch (err) {
    Swal.close()
    Swal.fire({
      icon: 'error', iconColor: '#ce501b', title: 'Error',
      text: err.response?.data?.mensaje || 'Hubo un problema al eliminar el documento',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    })
  }
}

	// ✅ Agregar función para limpiar al cerrar el modal
const cerrarModalIndexacion = () => {
  void limpiarEstadoPdfCarpeta()
  dialogIndexacion.value = false;
  indiceAnclaSeleccion.value = -1
  indiceFocusLista.value = -1
  zoomLevel.value = 1  // ✅ resetear zoom
  canvasHeights.value = {}
  // Limpiar datos
  estructuraPlantilla.value = [];
  valoresIndexacion.value = {};
  documentosNoIndexados.value = [];
  documentosIndexados.value = [];
  documentosSeleccionados.value = [];  // ← AGREGAR
  documentosIndexadosSeleccionados.value = [];  // ✅ desindexación
  modoSeleccionDesindexar.value = false;        // ✅ desindexación
  indiceFocusListaIndexados.value = -1;         // ✅ desindexación
  cargandoEstructura.value = false;
  cargandoDocumentos.value = false;
  tabIndexacion.value = 'no-indexados';
  urlVisorCarpeta.value = ''; //función nueva implementada para el visor
  cargandoVisorCarpeta.value = false; //función nueva implementada para el visor
  errorVisorCarpeta.value = ''; //función nueva implementada para el visor
  archivoNoVisualizableCarpeta.value = false;
  plantillaVisorCarpeta.value = null;
  docSeleccionadoVisor.value = null; //función nueva implementada para el visor
  pdfDocCarpeta.value = null; //función nueva implementada para el visor
  paginasRenderizadasCarpeta.value = new Set(); //función nueva implementada para el visor
  esVideoVisorCarpeta.value  = false;
  esAudioVisorCarpeta.value  = false;
  mimeVisorCarpeta.value     = '';

  // Cancelar cualquier carga pendiente del debounce de navegación
  if (visorNavTimeout) {
    clearTimeout(visorNavTimeout)
    visorNavTimeout = null
  }
  if (aperturaVisorTimeout) {
    clearTimeout(aperturaVisorTimeout)
    aperturaVisorTimeout = null
  }
  documentoPendienteVisor = null
  navegandoVisor = false

  // Cancelar precargas independientes del documento que se muestra
  prefetchVisorControllers.forEach(controller => controller.abort())
  prefetchVisorControllers.clear()
  prefetchVisorEnCurso.clear()
  idsVentanaVisor = new Set()
  indiceAnteriorVisor = null
  plantillaVentanaVisor = null
  candidatosPrefetchVisor = []

  // Liberar todos los blob URLs y pdfDocs parseados del caché
  visorCache.forEach(entrada => liberarEntradaCache(entrada))
  visorCache.clear()
  cargaIdActual.value = 0
  if (abortControllerVisor.value) {
    abortControllerVisor.value.abort()
    abortControllerVisor.value = null
  }
};



const esCampoFecha = (tipo) => {
  if (!tipo) return false;
  const tipoLower = tipo.toLowerCase();
  return tipoLower.includes('date') || tipoLower.includes('datetime');
};

const getOpcionesCombo = (valores) => {
  if (!valores) return [];
  return valores.split(',').map(v => v.trim());
};


const tienePermisoActual = computed(() => {
  return permisoActual.value !== '---' && 
         permisoActual.value !== 'Sin Acceso' &&
         permisoActual.value !== 'Error al consultar' &&
         permisoActual.value !== '' &&
         usuarioSeleccionado.value !== null;
});

// Computed para filtrar solo carpetas en los hijos
const folderChildren = computed(() => {
  if (!props.node.children) return [];
  return props.node.children.filter(child => child.tipo === 'c');
});

watch(
  folderChildren,
  hijos => {
    console.log('[ARBOL] folderChildren actualizado', {
      tocId: props.node.tocId,
      cantidad: hijos.length,
      hijos: hijos.map(hijo => ({
        tocId: hijo.tocId,
        tipo: hijo.tipo,
        nombre: hijo.name
      }))
    })
  },
  { immediate: true }
)

const getIconForType = (type) => {
  if (type === 'r') {
    return 'mdi-folder-network'; // Icono para DIRECTORIO PRINCIPAL
  } else if (type === 'c') {
    return 'mdi-folder';
  } else if (type === 'd') {
    return 'mdi-file-document-outline';
  }
  return 'mdi-folder';
};

const seleccionarCarpeta = () => {
  if (props.node.tipo === 'c' || props.node.tipo === 'r') {
    emit('folder-selected', props.node);
  }
};

const getActivatorPropsSinClick = (activatorProps) => {
  const propsSinClick = { ...activatorProps }
  delete propsSinClick.onClick
  return propsSinClick
}

const handleActivatorClick = (event, onClickVuetify) => {
  console.log('[ARBOL] handleActivatorClick antes', {
    tocId: props.node.tocId,
    tipoTocId: typeof props.node.tocId,
    childrenLoaded: props.node.childrenLoaded,
    ignorarClickDespuesDrag: ignorarClickDespuesDrag.value,
    tipoOnClickVuetify: typeof onClickVuetify
  })

  if (ignorarClickDespuesDrag.value) {
    ignorarClickDespuesDrag.value = false
    return
  }

  onClickVuetify?.(event)
  console.log('[ARBOL] handleActivatorClick después de Vuetify', {
    tocId: props.node.tocId
  })

  nextTick(() => {
    const grupo = event.currentTarget?.closest('.v-list-group')
    console.log('[ARBOL] estado DOM tras toggle', {
      tocId: props.node.tocId,
      abierto: grupo?.classList.contains('v-list-group--open')
    })
  })

  handleClick()
}

const handleClick = () => {
  console.log('[ARBOL] click carpeta', {
    tocId: props.node.tocId,
    childrenLoaded: props.node.childrenLoaded
  })

  // Cargar subcarpetas si no han sido cargadas
  if (!props.node.childrenLoaded) {
    emit('load-subcarpetas', props.node.tocId);
  }
  
  seleccionarCarpeta()
};

// Manejar click derecho
const handleRightClick = async (event) => {
  event.preventDefault();
  contextNode.value = props.node;

  // Posición inicial tentativa
  menuX.value = event.clientX;
  menuY.value = event.clientY;
  showContextMenu.value = true;

  // Corregir posición una vez que el menú esté en el DOM
  await nextTick();
  const menuEl = document.querySelector('.v-menu .v-list');
  if (menuEl) {
    const rect = menuEl.getBoundingClientRect();

    if (event.clientY + rect.height > window.innerHeight) {
      menuY.value = Math.max(0, event.clientY - rect.height);
    }
    if (event.clientX + rect.width > window.innerWidth) {
      menuX.value = Math.max(0, event.clientX - rect.width);
    }
  }
};

// Funciones del menú contextual

const exportar = async () => {
  showContextMenu.value = false

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    if (!idUsuarioSesion) {
      Swal.fire({ icon: 'error', iconColor: '#ce501b', title: 'Error',
        text: 'No se pudo obtener el usuario en sesión',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } })
      return
    }

    // Detectar templateId
    let templateId = contextNode.value.templateId
    if (!templateId && contextNode.value.children?.length > 0) {
      const hijo = contextNode.value.children.find(c => c.templateId > 0)
      if (hijo) templateId = hijo.templateId
    }
    if (!templateId) templateId = props.templateId

    if (!templateId || templateId === 0) {
      Swal.fire({ icon: 'warning', iconColor: '#ce501b', title: 'Sin plantilla',
        text: 'Esta carpeta no tiene una plantilla asignada. No se puede exportar.',
        confirmButtonColor: '#ce501b', confirmButtonText: 'Aceptar',
        customClass: { title: 'swal-title-custom', htmlContainer: 'swal-text-custom',
                       confirmButton: 'swal-btn-custom', container: 'swal-sobre-modal' } })
      return
    }

    // Confirmación
    const result = await Swal.fire({
      title: '¿Exportar documentos?',
      html: `<div style="text-align:left">
               <p>Carpeta: <strong>${contextNode.value.name}</strong></p>
               <p>Los documentos se convertirán a PDF y se descargarán en un ZIP.</p>
             </div>`,
      icon: 'question', iconColor: '#ce501b',
      showCancelButton: true,
      confirmButtonText: 'Sí, exportar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#ce501b',
      cancelButtonColor: '#9E9E9E',
      customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar',
                     cancelButton: 'swal-btn-cancelar', container: 'swal-sobre-modal' }
    })
    if (!result.isConfirmed) return

    // ✅ Lanzar en segundo plano — aparece en el chip del app bar
    procesarExportar({
      tocId:           contextNode.value.tocId,
      nombre:          contextNode.value.name,
      plantillaId:     templateId,
      idUsuarioSesion,
    })

    // Toast no bloqueante
    Swal.fire({
      toast: true, position: 'top-end',
      icon: 'info', iconColor: '#ce501b',
      title: 'Exportando en segundo plano…',
      text: 'Puedes seguir usando el sistema',
      timer: 2800, showConfirmButton: false,
      customClass: { container: 'swal-sobre-modal' }
    })

  } catch (error) {
    Swal.fire({ icon: 'error', iconColor: '#ce501b', title: 'Error',
      text: error.response?.data?.Mensaje || error.message || 'No se pudo exportar',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } })
  }
}




const propiedades = async () => {
  showContextMenu.value = false;
  
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    
    if (!idUsuarioSesion) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'No se pudo obtener la información del usuario en sesión',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
      return;
    }

    // Mostrar loading
    Swal.fire({
      title: 'Cargando propiedades...',
      allowOutsideClick: false,
      customClass: {
       loader: 'swal-loader-custom',
       container: 'swal-sobre-modal'
      },
      didOpen: () => {
        Swal.showLoading();
      }
    });

    //console.log('Obteniendo propiedades de carpeta:', contextNode.value.tocId);  //Usarlo solo para ver los errores en el testeo de Software

    const response = await axios.get(
      buildApiUrl(`/api/Doc/propiedades-carpeta/${contextNode.value.tocId}?idUsuarioSesion=${idUsuarioSesion}`)
    );

    Swal.close(); // Cerrar loading

    if (response.data.success) {
      const props = response.data.data;
      
      // Mostrar modal con las propiedades
      await Swal.fire({
        title: '<span style="color: #004d82">PROPIEDADES DE CARPETA</span>',
        html: `
          <div style="text-align: left; padding: 20px;">
            <table style="width: 100%; border-collapse: collapse;">
              
              <tr>
                <td style="padding: 8px 0; font-weight: bold;">Directorio:</td>
                <td style="padding: 8px 0; color: gray;">${contextNode.value.name}</td>
              </tr>

             <tr><td colspan="2"><hr style="border: 1px solid #efefef;"></td></tr>
             
               <tr>
                  <td style="padding: 6px 0; font-weight: bold;"><b>Tamaño (MB):</b></td>
                  <td style="padding: 6px 0; color: gray;">${props.pesoTotalMB}</td>
                </tr>
                
                <tr>
                  <td style="padding: 6px 0; font-weight: bold;"><b>Documentos:</b></td>
                  <td style="padding: 6px 0; color: gray;">${props.cantidadDocumentos}</td>
                </tr>


                <tr>
                  <td style="padding: 6px 0; font-weight: bold;"><b>Cant Imagen:</b></td>
                  <td style="padding: 6px 0; color: gray;">${props.cantidadImagenes}</td>
                </tr>

                <tr>
                  <td style="padding: 6px 0; font-weight: bold;"><b>Doc Indexados:</b></td>
                  <td style="padding: 6px 0; color: gray;">${props.documentosIndexados}</td>
                </tr>

                <tr>
                  <td style="padding: 6px 0; font-weight: bold;"><b>Doc No Indexados:</b></td>
                  <td style="padding: 6px 0; color: gray;">${props.documentosNoIndexados}</td>
                </tr>

            </table>
          </div>
        `,
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#ce501b',
        width: '500px',
        customClass: {
          confirmButton: 'swal-white-btn'
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudieron obtener las propiedades',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }
  } catch (error) {
    Swal.close(); // Cerrar loading si hay error
    //console.error('Error al obtener propiedades:', error);  //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al obtener las propiedades',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
      },
    });
  }
};

const indexacion = async () => {
  showContextMenu.value = false;
  
  try {
    /* //Usarlo solo para ver los errores en el testeo de Software
    console.log('=== DEBUG INDEXACION ===');
    console.log('contextNode.value completo:', contextNode.value);
    console.log('contextNode.value.templateId:', contextNode.value.templateId);
    console.log('contextNode.value.children:', contextNode.value.children);
    console.log('props.templateId:', props.templateId);
    console.log('========================');
    */
    // ✅ USAR LA MISMA LÓGICA QUE reconocimientoIndices
    let templateId = contextNode.value.templateId;
    
    //console.log('Template ID del nodo actual:', templateId);  //Usarlo solo para ver los errores en el testeo de Software
    //console.log('Nodo actual:', contextNode.value);  //Usarlo solo para ver los errores en el testeo de Software
    
    // Si la carpeta no tiene templateId (es 0 o null), buscar en sus hijos (archivos)
    if (!templateId && contextNode.value.children && contextNode.value.children.length > 0) {
      const hijoConTemplate = contextNode.value.children.find(child => child.templateId && child.templateId > 0);
      if (hijoConTemplate) {
        templateId = hijoConTemplate.templateId;
        //console.log('Template ID encontrado en hijo:', templateId);  //Usarlo solo para ver los errores en el testeo de Software
      }
    }
    
    // Si aún no hay, usar el del prop (heredado del padre)
    if (!templateId) {
      templateId = props.templateId;
      //console.log('Template ID del prop padre:', templateId); //Usarlo solo para ver los errores en el testeo de Software
    }
    
    // Validar que tengamos un templateId válido
    if (!templateId || templateId === 0) {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ce501b',
        title: '<span style="color: #004d82;">Sin plantilla</span>',
        text: 'Esta carpeta no tiene una plantilla asignada. Asegúrese de que la carpeta contenga documentos con plantilla.',
        confirmButtonText: 'Aceptar', // ← Cambiar texto del botón
        confirmButtonColor: '#ce501b', // ← Cambiar color de fondo del botón
        customClass: {
          confirmButton: 'swal-btn-confirmar', // ← Aplicar clase para letra blanca
          container: 'swal-sobre-modal'
        }
      });
      return;
    }

    cargandoEstructura.value = true;

    //console.log('Llamando API estructura con templateId:', templateId);  //Usarlo solo para ver los errores en el testeo de Software

    // Llamar al API para obtener estructura de la plantilla
    const response = await axios.get(
      buildApiUrl(`/api/Plantillas/estructura/${templateId}`)
    );

    cargandoEstructura.value = false;

    if (response.data.success && response.data.data.length > 0) {
      estructuraPlantilla.value = response.data.data;
      
      // Inicializar valores vacíos para cada campo
      valoresIndexacion.value = {};
      estructuraPlantilla.value.forEach(campo => {
        valoresIndexacion.value[campo.column_name] = '';
      });


     // ✅ CARGAR DOCUMENTOS INDEXADOS Y NO INDEXADOS
      cargandoDocumentos.value = true;
      await Promise.all([
        obtenerArchivosNoIndexados(contextNode.value.tocId, templateId),
        obtenerArchivosIndexados(contextNode.value.tocId, templateId)
      ]);
      cargandoDocumentos.value = false;

      // Abrir modal
 
      dialogIndexacion.value = true
      await nextTick()

      // ✅ Mostrar primer documento en el visor sin marcarlo
      const primerDoc = documentosNoIndexados.value[0]
      if (primerDoc) {
        verDocumento(primerDoc, 0, true)  // true = enfocar campo al terminar
      } else {
        enfocarPrimerCampo()  // si no hay doc, enfocar directo
      }

    } else {
      Swal.fire({
        icon: 'info',
        iconColor: '#ce501b',
        title: 'Sin campos',
        text: 'Esta plantilla no tiene campos disponibles',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }
    
  } catch (error) {
    cargandoEstructura.value = false;
    //console.error('Error al cargar estructura:', error);  //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al cargar la estructura',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
  }
};


// ✅ Función para formatear fecha a YYYY-MM-DD
const formatearFecha = (valor) => {
  if (!valor) return '';
  
  // Si ya está en formato YYYY-MM-DD, devolverlo tal cual
  if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
    return valor;
  }
  
  const fecha = new Date(valor);
  if (isNaN(fecha.getTime())) return valor;
  
  const year = fecha.getFullYear();
  const month = String(fecha.getMonth() + 1).padStart(2, '0');
  const day = String(fecha.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};


// ── Desindexar los documentos indexados marcados con check (nuevo API) ──
const desindexarDocumentos = async () => {
  const docsADesindexar = documentosIndexados.value.filter(
    doc => documentosIndexadosSeleccionados.value.includes(doc.tocId)
  );
  if (docsADesindexar.length === 0) return;

  // ✅ Confirmación antes de desindexar
  const confirmacion = await Swal.fire({
    title: '¿Está seguro?',
    html: `¿Desea <strong>desindexar</strong> los <strong>${docsADesindexar.length}</strong> documento(s) seleccionados?`,
    icon: 'warning',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonText: 'Sí, desindexar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    focusConfirm: true,
    allowEnterKey: true,
    keydownListenerCapture: true,
    customClass: {
      title: 'swal-title-custom',
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
    },
    didOpen: () => {
      const btn = Swal.getConfirmButton()
      if (btn) btn.focus()
    }
  });

  if (!confirmacion.isConfirmed) return;

  // ── Resolver templateId con fallbacks (igual que guardarIndexacion) ──
  let templateId = templateIdEncontrado.value || contextNode.value.templateId;
  if (!templateId || templateId === 0) {
    const hijo = contextNode.value.children?.find(c => c.templateId > 0);
    if (hijo) templateId = hijo.templateId;
  }
  if (!templateId || templateId === 0) templateId = props.templateId;

  if (!templateId || templateId === 0) {
    Swal.fire({
      icon: 'error', iconColor: '#ce501b', title: 'Error',
      text: 'No se pudo determinar la plantilla. Intente nuevamente.',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
    return;
  }

  const idUsuarioSesion = localStorage.getItem('idUsuario');

  Swal.fire({
    title: 'Desindexando...',
    html: `Procesando ${docsADesindexar.length} documento(s)...`,
    allowOutsideClick: false,
    customClass: { title: 'swal-title-custom', loader: 'swal-loader-custom', container: 'swal-sobre-modal' },
    didOpen: () => Swal.showLoading()
  });

  let procesados = 0;
  const errores = [];

  // El API desindexa un tocId por llamada → se procesa uno a uno
  for (const doc of docsADesindexar) {
    try {
      const res = await axios.put(
        buildApiUrl(`/api/Desindexacion/desindexar?idUsuarioSesion=${idUsuarioSesion}`),
        {
          tocId: doc.tocId,
          idplantilla: parseInt(templateId)
        }
      );

      // El DTO del backend expone "Succes" → llega como "succes" en el JSON
      const ok = res.data?.succes ?? res.data?.success ?? true;
      if (ok) {
        procesados++;
        Swal.update({ html: `Desindexados <strong>${procesados}</strong> de ${docsADesindexar.length}...` });
      } else {
        errores.push({ nombre: doc.nameToc, error: res.data?.mensaje || 'Error desconocido' });
      }
    } catch (err) {
      errores.push({ nombre: doc.nameToc, error: err.response?.data?.mensaje || err.message });
    }
  }

  Swal.close();

  if (errores.length === 0) {
    await Swal.fire({
      icon: 'success', iconColor: '#ce501b', title: '¡Desindexado!',
      html: `Se desindexaron <strong>${procesados}</strong> documento(s) correctamente`,
      timer: 2000, showConfirmButton: false,
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
  } else {
    const detalle = errores.map(e => `<li><strong>${e.nombre}</strong>: ${e.error}</li>`).join('');
    await Swal.fire({
      icon: procesados > 0 ? 'warning' : 'error',
      iconColor: '#ce501b',
      title: procesados > 0 ? 'Desindexado parcial' : 'Error al desindexar',
      html: `
        <p>Desindexados: <strong>${procesados}</strong> — Errores: <strong>${errores.length}</strong></p>
        <ul style="text-align:left; font-size:12px; max-height:150px; overflow-y:auto;">${detalle}</ul>
      `,
      confirmButtonColor: '#ce501b',
      customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal' }
    });
  }

  // ── Limpiar selección y recargar listas sin cerrar el modal ──
  documentosIndexadosSeleccionados.value = [];
  modoSeleccionDesindexar.value = false;
  indiceFocusListaIndexados.value = -1;

  cargandoDocumentos.value = true;
  await Promise.all([
    obtenerArchivosNoIndexados(contextNode.value.tocId, templateId),
    obtenerArchivosIndexados(contextNode.value.tocId, templateId)
  ]);
  cargandoDocumentos.value = false;

  emit('reload-subcarpetas', contextNode.value.tocId);
  emit('folder-selected', contextNode.value);
};


const guardarIndexacion = async () => {

  // ✅ Si hay documentos INDEXADOS marcados con check → desindexar (nuevo API)
  if (documentosIndexadosSeleccionados.value.length > 0) {
    await desindexarDocumentos();
    return;
  }

  if (documentosSeleccionados.value.length === 0) {
    await Swal.fire({
      icon: 'warning', iconColor: '#ce501b', title: 'Sin selección',
      text: 'Debe seleccionar al menos un documento para indexar',
      confirmButtonColor: '#ce501b',
      customClass: { title: 'swal-title-custom', confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal' }
    })
    return
  }

  // ✅ Confirmación antes de guardar
  const confirmacion = await Swal.fire({
    title: '¿Está seguro?',
    text: '¿Desea guardar la indexación de los documentos seleccionados?',
    icon: 'warning',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonText: 'Sí, guardar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    focusConfirm: true,                    // ✅ Enter cae en "Sí, guardar" 
    allowEnterKey: true,              // ✅ Enter confirma
    keydownListenerCapture: true,     // ✅ captura el Enter antes que Vuetify
    customClass: {
      title: 'swal-title-custom',
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
    },
     didOpen: () => {                        // ✅ refuerza el foco
      const btn = Swal.getConfirmButton()
     if (btn) btn.focus()
    }

  });

  if (!confirmacion.isConfirmed) return;


  try {
    /* //Se bloqueo este bloque de codigo que permite no ingresar datos vacios.

    const tieneValores = Object.values(valoresIndexacion.value).some(v => v !== '' && v !== null);
    if (!tieneValores) {
      Swal.fire({
        icon: 'warning', iconColor: '#ce501b', title: 'Datos incompletos',
        text: 'Debe completar al menos un campo',
        confirmButtonColor: '#ce501b',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal', confirmButton: 'swal-btn-confirmar' }
      });
      return;
    }
    */
    // ── Resolver templateId con fallbacks ──
    let templateId = templateIdEncontrado.value || contextNode.value.templateId;
    if (!templateId || templateId === 0) {
      const hijo = contextNode.value.children?.find(c => c.templateId > 0);
      if (hijo) templateId = hijo.templateId;
    }
    if (!templateId || templateId === 0) templateId = props.templateId;

    if (!templateId || templateId === 0) {
      Swal.fire({
        icon: 'error', iconColor: '#ce501b', title: 'Error',
        text: 'No se pudo determinar la plantilla. Intente nuevamente.',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
      return;
    }

    const idUsuarioSesion = localStorage.getItem('idUsuario');
    const documentosAProcesar = documentosNoIndexados.value.filter(
      doc => documentosSeleccionados.value.includes(doc.tocId)
    );

    // ── Construir campos ──
    const campos = [];
    for (const campo of estructuraPlantilla.value) {
      const valor = valoresIndexacion.value[campo.column_name];

      // 1) Detectar el tipo de dato
      let tipoDato = 'varchar';
      let esFecha = false;
      let esEntero = false;

      if (campo.data_type) {
        const t = campo.data_type.toLowerCase();
        if (t.includes('date')) {
          tipoDato = 'datetime';
          esFecha = true;
        } else if (t.includes('int') || t.includes('numeric') || t.includes('decimal')) {
          tipoDato = 'int';
          esEntero = true;
        }
      }

      // 2) ¿Campo vacío?
      const vacio = valor === '' || valor === null || valor === undefined;

      // 3) Resolver el valor final
      let valorFinal;
      if (vacio) {
        if (esEntero)      valorFinal = '0';   // int  → 0
        else if (esFecha)  valorFinal = ' ';   // date → espacio
        else               valorFinal = '  ';  // varchar → dos espacios
      } else {
        valorFinal = esFecha ? formatearFecha(valor) : valor.toString();
      }

      campos.push({ nombreCampo: campo.column_name, valor: valorFinal, tipoDato });
    }

    // ── Mostrar loading inicial ──
    Swal.fire({
      title: 'Guardando indexación...',
      html: `Procesando ${documentosAProcesar.length} documento(s)...`,
      allowOutsideClick: false,
      customClass: { title: 'swal-title-custom', loader: 'swal-loader-custom' },
      didOpen: () => Swal.showLoading()
    });

    let procesados = 0;
    const errores = [];

    // ════════════════════════════════════════════════════════
    // CASO A: UN solo documento → /insertar
    // ════════════════════════════════════════════════════════
    if (documentosAProcesar.length === 1) {
      Swal.update({ html: `Indexando 1 documento...` });

      try {
        const res = await axios.post(
          buildApiUrl(`/api/Indexacion/insertar?idUsuarioSesion=${idUsuarioSesion}`),
          {
            plantillaId: parseInt(templateId),
            tocId: documentosAProcesar[0].tocId,
            campos: campos
          }
        );

        if (res.data.success) {
          procesados = 1;
        } else {
          errores.push({
            tocId: documentosAProcesar[0].tocId,
            nombre: documentosAProcesar[0].nameToc,
            error: res.data.mensaje
          });
        }
      } catch (err) {
        errores.push({
          tocId: documentosAProcesar[0].tocId,
          nombre: documentosAProcesar[0].nameToc,
          error: err.response?.data?.mensaje || err.message
        });
      }

    // ════════════════════════════════════════════════════════
    // CASO B: MÚLTIPLES documentos → /insertar_todos
    // ════════════════════════════════════════════════════════
    } else {

        // ✅ Solo se permite indexar múltiples si TODOS son imágenes (png, tiff, jpg, jpeg)
      const formatosMultiplePermitido = ['png', 'tiff', 'tif', 'jpg', 'jpeg']

      const archivosNoImagen = documentosAProcesar.filter(doc => {
        const ext = (doc.nameToc || '').split('.').pop().toLowerCase()
        return !formatosMultiplePermitido.includes(ext)
      })

      if (archivosNoImagen.length > 0) {
        // Agrupar por extensión para el mensaje
        const conteo = {}
        archivosNoImagen.forEach(doc => {
          const ext = (doc.nameToc || '').split('.').pop().toLowerCase()
          conteo[ext] = (conteo[ext] || 0) + 1
        })

        const detalle = Object.entries(conteo)
          .map(([ext, cnt]) => `<strong style="color:#ce501b;">${cnt}</strong> archivo(s) .${ext.toUpperCase()}`)
          .join(', ')

        Swal.close()
        Swal.fire({
          icon: 'warning',
          iconColor: '#ce501b',
          title: 'No permitido',
          html: `
            <p>Solo se pueden indexar múltiples archivos de tipo imagen (PNG, TIFF, JPG, JPEG).</p>
            <p style="margin-top: 8px; font-size: 13px; color: #666;">
              Se encontraron archivos no permitidos para indexación múltiple: ${detalle}
            </p>
            <p style="margin-top: 8px; font-size: 13px; color: #666;">
              Para este tipo de archivos, indexe <strong>uno a la vez</strong>.
            </p>
          `,
          confirmButtonColor: '#ce501b',
          confirmButtonText: 'Entendido',
          timer: 8000,
          timerProgressBar: true,
          showConfirmButton: true,
          customClass: {
            title: 'swal-title-custom',
            confirmButton: 'swal-btn-confirmar',
            container: 'swal-sobre-modal'
          }
        })
        return
      }

      Swal.update({
        html: `Indexando ${documentosAProcesar.length} documentos...`
      });

      try {
        const res = await axios.post(
          buildApiUrl(`/api/Indexacion/insertar_todos?idUsuarioSesion=${idUsuarioSesion}`),
          {
            tocIds: documentosAProcesar.map(d => d.tocId),
            plantillaId: parseInt(templateId),                   // ← plantilla
            campos: campos                                   // ← mismos campos que /insertar
          }
        );

        if (res.data.success) {
          procesados = documentosAProcesar.length;
          Swal.update({
            html: `Se procesaron <strong>${procesados}</strong> documentos correctamente`
          });
        } else {
          documentosAProcesar.forEach(d => {
            errores.push({
              tocId: d.tocId,
              nombre: d.nameToc,
              error: res.data.mensaje
            });
          });
        }
      } catch (err) {
        documentosAProcesar.forEach(d => {
          errores.push({
            tocId: d.tocId,
            nombre: d.nameToc,
            error: err.response?.data?.mensaje || err.message
          });
        });
      }
    }

    Swal.close();

    // ════════════════════════════════════════════════════════
    // RESULTADO FINAL
    // ════════════════════════════════════════════════════════
    if (errores.length === 0) {
      await Swal.fire({
        icon: 'success', iconColor: '#ce501b', title: '¡Guardado!',
        html: `Se indexaron <strong>${procesados}</strong> documento(s) correctamente`,
        timer: 2000, showConfirmButton: false,
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });

      
      // Recargar listas sin cerrar el modal
      const tplId = templateIdEncontrado.value || contextNode.value.templateId || props.templateId;
      cargandoDocumentos.value = true;
      await Promise.all([
        obtenerArchivosNoIndexados(contextNode.value.tocId, tplId),
        obtenerArchivosIndexados(contextNode.value.tocId, tplId)
      ]);
      cargandoDocumentos.value = false;

      // ✅ Esperar que Vue actualice la lista con los nuevos documentos
      await nextTick()
      await nextTick()

      // Limpiar selección y formulario (excepto el primer campo)
      documentosSeleccionados.value = [];
      indiceAnclaSeleccion.value = -1
      indiceFocusLista.value = -1
      estructuraPlantilla.value.forEach(c => {
        valoresIndexacion.value[c.column_name] = '';
      });

      emit('reload-subcarpetas', contextNode.value.tocId);
      emit('folder-selected', contextNode.value);

      // ✅ Mostrar el primer documento actualizado en el visor (sin marcarlo)
      const primerDoc = documentosNoIndexados.value[0]
      if (primerDoc) {
        docSeleccionadoVisor.value = primerDoc

        let templateId = contextNode.value.templateId
        if (!templateId && contextNode.value.children?.length > 0) {
          const hijo = contextNode.value.children.find(c => c.templateId > 0)
          if (hijo) templateId = hijo.templateId
        }
        if (!templateId) templateId = props.templateId

        if (templateId) {
          await cargarVisorCarpeta(primerDoc.tocId, templateId)
        }
      }

      // ✅ Mover el foco al primer campo
      enfocarPrimerCampo();


    } else if (procesados > 0) {
      cerrarModalIndexacion();

      await Swal.fire({
        icon: 'warning', iconColor: '#ce501b', title: 'Indexación parcial',
        html: `
          <p>Se indexaron <strong>${procesados}</strong> documento(s) correctamente.</p>
          <p style="color:#d32f2f;">${errores.length} documento(s) con error:</p>
          <ul style="text-align:left; max-height:150px; overflow-y:auto;">
            ${errores.map(e => `<li>${e.nombre}: ${e.error}</li>`).join('')}
          </ul>`,
        confirmButtonColor: '#ce501b', confirmButtonText: 'OK',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
          confirmButton: 'swal-btn-confirmar'
        }
      });

      emit('reload-subcarpetas', contextNode.value.tocId);
      emit('folder-selected', contextNode.value);

    } else {
      Swal.fire({
        icon: 'error', iconColor: '#ce501b', title: 'Error',
        html: `
          <p>No se pudo indexar ningún documento.</p>
          <ul style="text-align:left; max-height:150px; overflow-y:auto;">
            ${errores.map(e => `<li>${e.nombre}: ${e.error}</li>`).join('')}
          </ul>`,
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
    }

  } catch (error) {
    Swal.close();
    Swal.fire({
      icon: 'error', iconColor: '#ce501b', title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al guardar la indexación',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
  }
};


const reconocimientoIndices = async () => {
  showContextMenu.value = false;
  
  try {
    // ✅ SOLUCIÓN: Usar el templateId del nodo donde se hizo clic derecho
    let templateId = contextNode.value.templateId;
    
    //console.log('Template ID del nodo actual:', templateId);  //Usarlo solo para ver los errores en el testeo de Software
    //console.log('Nodo actual:', contextNode.value);   //Usarlo solo para ver los errores en el testeo de Software
    
    // Si la carpeta no tiene templateId (es 0 o null), buscar en sus hijos (archivos)
    if (!templateId && contextNode.value.children && contextNode.value.children.length > 0) {
      const hijoConTemplate = contextNode.value.children.find(child => child.templateId && child.templateId > 0);
      if (hijoConTemplate) {
        templateId = hijoConTemplate.templateId;
        //console.log('Template ID encontrado en hijo:', templateId);  //Usarlo solo para ver los errores en el testeo de Software
      }
    }
    
    // Si aún no hay, usar el del prop (heredado del padre)
    if (!templateId) {
      templateId = props.templateId;
      //console.log('Template ID del prop padre:', templateId);  //Usarlo solo para ver los errores en el testeo de Software
    }
    
    // Validar que tengamos un templateId válido
    if (!templateId || templateId === 0) {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Sin plantilla',
        text: 'Esta carpeta no tiene una plantilla asignada. Asegúrese de que la carpeta contenga documentos con plantilla.',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
      return;
    }

    // ✅ GUARDAR EL TEMPLATE ID ENCONTRADO
    templateIdEncontrado.value = templateId;
    //console.log('Template ID guardado para generar índices:', templateIdEncontrado.value);  //Usarlo solo para ver los errores en el testeo de Software

    cargandoColumnas.value = true;

    const response = await axios.get(
      buildApiUrl(`/api/Plantillas/campos/${templateId}`)
    );

    cargandoColumnas.value = false;

    if (response.data.success && response.data.data.length > 0) {
      columnas.value = response.data.data.map(campo => ({
        id: campo.nombre_campo,
        nombre: campo.nombre_campo
      }));

      columnaSeleccionada.value = null;
      dialogGenerarIndices.value = true;
    } else {
      Swal.fire({
        icon: 'info',
        iconColor: '#ce501b',
        title: 'Sin campos',
        text: 'Esta plantilla no tiene campos disponibles para indexación',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
    }
    
  } catch (error) {
    cargandoColumnas.value = false;
    //console.error('Error al cargar columnas:', error);   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al cargar las columnas',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
  }
};




const generarIndices = async () => {
  if (!columnaSeleccionada.value) {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ce501b',
      title: 'Datos incompletos',
      confirmButtonColor: '#ce501b',
      text: 'Debe seleccionar una columna',
      customClass: {
        title: 'swal-title-custom',
        confirmButton: 'swal-btn-confirmar',
        container: 'swal-sobre-modal'
      },
    });
    return;
  }

  // ✅ Validar que tengamos templateId
  if (!templateIdEncontrado.value || templateIdEncontrado.value === 0) {
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'No se pudo determinar la plantilla. Intente nuevamente.',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
      }
    });
    return;
  }

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');

    // Mostrar loading
    Swal.fire({
      title: 'Generando índices...',
      html: 'Procesando documentos, por favor espere...',
      allowOutsideClick: false,
      customClass: {
       loader: 'swal-loader-custom',
       title: 'swal-title-custom',
       container: 'swal-sobre-modal'
      },
      didOpen: () => {
        Swal.showLoading();
      }
    });
   /*   //Usarlo solo para ver los errores en el testeo de Software
    console.log('Enviando request con:', {
      tocId: contextNode.value.tocId,
      plantillaId: templateIdEncontrado.value,  // ✅ USAR EL GUARDADO
      campo: columnaSeleccionada.value
    });
  */
    // ✅ Llamar al API real con el templateId correcto
    const response = await axios.post(
      buildApiUrl(`/api/Plantillas/barcode?idUsuarioSesion=${idUsuarioSesion}`),
      {
        tocId: contextNode.value.tocId,
        plantillaId: templateIdEncontrado.value,  // ✅ CAMBIO AQUÍ
        campo: columnaSeleccionada.value
      }
    );

    Swal.close();

    // Cerrar dialog
    dialogGenerarIndices.value = false;

    if (response.data.success) {
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Éxito!',
        html: `${response.data.mensaje}<br>Códigos encontrados: ${response.data.codigosEncontrados}`,
        confirmButtonText: 'OK',
        confirmButtonColor: '#ce501b',
           customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
          confirmButton: 'swal-btn-confirmar'
        }
      });
    } else {
      await Swal.fire({
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Advertencia',
        text: response.data.mensaje,
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }

  } catch (error) {
    Swal.close();
    //console.error('Error al generar índices:', error);       //Usarlo solo para ver los errores en el testeo de Software
    //console.error('Response data:', error.response?.data);   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al generar los índices',
           customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
  }
};




// Función para crear directorio
const crearDirectorio = async () => {
  showContextMenu.value = false;
  
  const { value: nombreDirectorio } = await Swal.fire({
    title: '<span style="color: #004d82;">Agregar nuevo directorio</span>',
    input: 'text',
    inputLabel: 'Nombre directorio',
    inputPlaceholder: 'Ingrese el nombre del directorio',
    showCancelButton: true,
    confirmButtonText: 'Guardar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9E9E9E',
    customClass: {
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
     },
    inputValidator: (value) => {
      if (!value) {
        return 'Debe ingresar un nombre para el directorio'
      }
    }
  });

  if (nombreDirectorio) {
    try {
      const idUsuarioSesion = localStorage.getItem('idUsuario');
      
      if (!idUsuarioSesion) {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: 'No se pudo obtener la información del usuario en sesión',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
         }
        });
        return;
      }

      const payload = {
        parentId: contextNode.value.tocId,
        name: nombreDirectorio
      };

      //console.log('Creando directorio:', payload);    //Usarlo solo para ver los errores en el testeo de Software

      const response = await axios.post(
        buildApiUrl(`/api/Toc/crear-directorio?idUsuarioSesion=${idUsuarioSesion}`),
        payload
      );

      if (response.data.success) {
        await Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Éxito!',
          text: 'Directorio creado exitosamente',
          timer: 2500,
          confirmButtonColor: '#ce501b',
           customClass: {
           title: 'swal-title-custom',
           container: 'swal-sobre-modal',
           confirmButton: 'swal-btn-confirmar'
          },
          showConfirmButton: true
        });

        // ✅ FORZAR RECARGA de subcarpetas del nodo padre
        emit('reload-subcarpetas', contextNode.value.tocId);
        emit('expand-node', contextNode.value.tocId);   // ← abre visualmente el grupo
        emit('folder-selected', contextNode.value);

      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudo crear el directorio',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        });
      }
    } catch (error) {
      //console.error('Error al crear directorio:', error);    //Usarlo solo para ver los errores en el testeo de Software
      
      if (error.response?.status === 400) {
        Swal.fire({
          icon: 'warning',
          iconColor: '#ce501b',
          title: 'Advertencia',
          text: error.response?.data?.mensaje || 'Ya existe un directorio con ese nombre',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: 'Hubo un problema al crear el directorio',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        });
      }
    }
  }
};

const cambiarNombre = async () => {
  showContextMenu.value = false;
  
  const { value: nuevoNombre } = await Swal.fire({
    title: 'Cambiar nombre',
    input: 'text',
    inputLabel: 'Nuevo nombre',
    inputValue: contextNode.value.name, // Mostrar nombre actual
    inputPlaceholder: 'Ingrese el nuevo nombre',
    showCancelButton: true,
    confirmButtonText: 'Guardar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
      customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          cancelButton: 'swal-btn-cancelar',
          container: 'swal-sobre-modal'
        },
    inputValidator: (value) => {
      if (!value) {
        return 'Debe ingresar un nombre'
      }
    }
  });

  if (nuevoNombre && nuevoNombre !== contextNode.value.name) {
    try {
      const idUsuarioSesion = localStorage.getItem('idUsuario');
      
      if (!idUsuarioSesion) {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: 'No se pudo obtener la información del usuario en sesión',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
        },
        });
        return;
      }

      const payload = {
        tocId: contextNode.value.tocId,
        name: nuevoNombre
      };

      //console.log('Renombrando:', payload);  //Usarlo solo para ver los errores en el testeo de Software

      const response = await axios.put(
        buildApiUrl(`/api/Toc/renombrar?idUsuarioSesion=${idUsuarioSesion}`),
        payload
      );

      if (response.data.success) {
        await Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Éxito!',
          text: 'Nombre actualizado exitosamente',
          timer: 2500,
          confirmButtonColor: '#ce501b',
          customClass: {
            title: 'swal-title-custom',
            confirmButton: 'swal-btn-confirmar',
            container: 'swal-sobre-modal'
        },
          showConfirmButton: true
        });

        // Actualizar el nombre localmente en el nodo
        contextNode.value.name = nuevoNombre;
        
        // Recargar subcarpetas del padre para reflejar el cambio
        if (contextNode.value.parentId) {
          emit('reload-subcarpetas', contextNode.value.parentId);
        }
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudo actualizar el nombre',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        });
      }
    } catch (error) {
      //console.error('Error al renombrar:', error);  //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || 'Hubo un problema al cambiar el nombre',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }
  }
};

const eliminarDirectorio = async () => {
  showContextMenu.value = false;
  
  // Confirmación con advertencia
  const result = await Swal.fire({
    title: '<span style="color: #004d82">¿Estás seguro?</span>',
    html: `
      <div style="text-align: left;">
        <p style="color: gray">Vas a eliminar el directorio:</p>
        <p style="font-weight: bold; color: #ce501b; margin: 10px 0;">${contextNode.value.name}</p>
        <p style="color: #ce501b;"> <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#ce501b" style="vertical-align: middle; margin-right: 4px;">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
          </svg> Esta acción eliminará:</p>
        <ul style="text-align: left; margin-left: 20px;">
          <li style="color: gray">El directorio y todas sus subcarpetas</li>
          <li style="color: gray">Todos los documentos contenidos</li>
          <li style="color: gray">Todos los datos indexados</li>
        </ul>
        <p style="color: #ce501b; font-weight: bold; margin-top: 15px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#ce501b" style="vertical-align: middle; margin-right: 4px;">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
          </svg> ESTA ACCIÓN NO SE PUEDE DESHACER
        </p>
      </div>
    `,
    icon: 'warning',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonText: 'Eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    reverseButtons: false,
    width: '500px',
    customClass: { // ← AGREGAR ESTO
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
    }
  });

  if (result.isConfirmed) {
    try {
      const idUsuarioSesion = localStorage.getItem('idUsuario');
      
      if (!idUsuarioSesion) {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: 'No se pudo obtener la información del usuario en sesión',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          },
        });
        return;
      }

      // Mostrar loading
      Swal.fire({
        title: 'Eliminando directorio...',
        html: 'Por favor espera, esto puede tomar algunos minutos.',
        customClass: {
          loader: 'swal-loader-custom',
          title: 'swal-title-custom'
        },
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const payload = {
        tocId: contextNode.value.tocId
      };

      //console.log('Eliminando directorio:', payload);  //Usarlo solo para ver los errores en el testeo de Software

      const response = await axios.delete(
        buildApiUrl(`/api/Toc/eliminar-directorio?idUsuarioSesion=${idUsuarioSesion}`),
        { data: payload }
      );

      Swal.close(); // Cerrar loading

      if (response.data.success) {
        await Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Eliminado!',
          text: 'El directorio ha sido eliminado exitosamente',
          timer: 2500,
          confirmButtonColor: '#ce501b',
          customClass: {
            title: 'swal-title-custom',
            confirmButton: 'swal-btn-confirmar',
            container: 'swal-sobre-modal'
          },
          showConfirmButton: true
        });

        // Recargar subcarpetas del padre
            
       emit('reload-subcarpetas', contextNode.value.parentId || 0);
       emit('folder-deleted', contextNode.value.tocId);

          
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudo eliminar el directorio',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
        },
        });
      }
    } catch (error) {
      Swal.close(); // Cerrar loading si hay error
      //console.error('Error al eliminar directorio:', error);  //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || 'Hubo un problema al eliminar el directorio',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }
  }
};

// Función para importar archivo externo

const importarArchivoExterno = async () => {
  showContextMenu.value = false

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    if (!idUsuarioSesion) {
      Swal.fire({ icon: 'error', iconColor: '#ce501b', title: 'Error',
        text: 'No se pudo obtener el usuario en sesión',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } })
      return
    }

    const [resPlt, resVol] = await Promise.all([
      axios.get(buildApiUrl(`/api/Plantillas/list-plantillas?idUsuarioSesion=${idUsuarioSesion}`)),
      axios.get(buildApiUrl('/api/Volumenes/list-volumenes'))
    ])

    const volumenesActivos = resVol.data.data.filter(v => v.estado === 1)
    const plantillasLista  = resPlt.data.data

    if (!volumenesActivos.length) {
      Swal.fire({ icon: 'warning', iconColor: '#ce501b', title: 'Sin volúmenes',
        text: 'No hay volúmenes activos disponibles',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } })
      return
    }
    if (!plantillasLista.length) {
      Swal.fire({ icon: 'warning', iconColor: '#ce501b', title: 'Sin plantillas',
        text: 'No hay plantillas disponibles para este usuario',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } })
      return
    }

    // Detectar templateId de la carpeta
    let templateIdDetectado = 0
    if (contextNode.value.children?.length > 0) {
      const hijo = contextNode.value.children.find(c => c.templateId > 0)
      if (hijo) templateIdDetectado = hijo.templateId
    }
    if (!templateIdDetectado && contextNode.value.templateId > 0)
      templateIdDetectado = contextNode.value.templateId

    // ✅ El diálogo y el upload viven en el singleton (ImportarBg.vue / menuForm.vue)
    abrirImportar({
      id:                 contextNode.value.tocId,
      nombre:             contextNode.value.name,
      plantillasLista,
      volumenesLista:     volumenesActivos,
      templateIdDetectado,
    })

  } catch (error) {
    Swal.fire({ icon: 'error', iconColor: '#ce501b', title: 'Error',
      text: 'Hubo un problema al cargar los datos necesarios',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' } })
  }
}





const asignarQuitarPermiso = async () => {
  showContextMenu.value = false;
  
  try {
    

    // Cargar usuarios y tipos de permiso
    const [usuariosResponse, permisosResponse] = await Promise.all([
      axios.get(buildApiUrl('/api/Users/list-usuarios-grupos')),
      axios.get(buildApiUrl('/api/TipoPermiso/listar'))
    ]);

    if (usuariosResponse.data.success) {
      usuarios.value = usuariosResponse.data.data;
    }

    if (permisosResponse.data.success) {
      tiposPermiso.value = permisosResponse.data.data;
    }

    // Resetear valores
    usuarioSeleccionado.value = null;
    permisoSeleccionado.value = null;
    permisoActual.value = '---';

    // Abrir dialog
    dialogPermisos.value = true;

  } catch (error) {
    //console.error('Error al cargar datos:', error);  //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Hubo un problema al cargar los datos necesarios',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
  }
};


const cargarPermisoActual = async () => {
  if (!usuarioSeleccionado.value) {
    permisoActual.value = '---';
    return;
  }

  cargandoPermisoActual.value = true;
  
  try {
    const response = await axios.post(
      buildApiUrl('/api/TipoPermiso/validar-permiso'),
      {
        idUsuario: usuarioSeleccionado.value,
        tocId: contextNode.value.tocId
      }
    );

    if (response.data.success || response.data.data) {
      permisoActual.value = response.data.data?.tipo || 'Sin Acceso';
    } else {
      permisoActual.value = 'Sin Acceso';
    }
  } catch (error) {
    //console.error('Error al validar permiso:', error);  //Usarlo solo para ver los errores en el testeo de Software
    permisoActual.value = 'Error al consultar';
  } finally {
    cargandoPermisoActual.value = false;
  }
};


const guardarPermiso = async () => {
  if (!usuarioSeleccionado.value || !permisoSeleccionado.value) {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ce501b',
      title: 'Datos incompletos',
      text: 'Debe seleccionar un usuario y un permiso',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
    return;
  }

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');

    // Mostrar loading
    Swal.fire({
      title: 'Guardando permiso...',
      allowOutsideClick: false,
      customClass: {
       loader: 'swal-loader-custom',
       title: 'swal-title-custom'
      },
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const response = await axios.post(
      buildApiUrl(`/api/Grupos/registrar-permiso?idUsuarioSesion=${idUsuarioSesion}`),
      {
        idGrupo: usuarioSeleccionado.value,
        tipoPermiso: permisoSeleccionado.value,
        tocId: contextNode.value.tocId
      }
    );

    Swal.close();

    if (response.data.success) {

      // ── Invalidar cache de permisos del usuario en sesión ──
      const idU = localStorage.getItem('idUsuario')
      localStorage.removeItem(`permisosCarpetas_${idU}`)
      delete window[`__permisosCarpetasPromise_${idU}`]

      // ✅ Cerrar dialog PRIMERO
      dialogPermisos.value = false;
      
      // ✅ Luego mostrar mensaje
      await Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        iconColor: '#ce501b',
        text: 'Permiso asignado exitosamente',
        timer: 2000,
        confirmButtonColor: '#ce501b',
        customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'
        },
        showConfirmButton: true
      });

      // ✅ Ya NO recargar permiso actual (el dialog está cerrado)
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudo guardar el permiso',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }
  } catch (error) {
    Swal.close();
    //console.error('Error al guardar permiso:', error);  //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al guardar el permiso',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal'
      }
    });
  }
};


const quitarPermiso = async () => {
  if (!usuarioSeleccionado.value) {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ce501b',
      title: 'Datos incompletos',
      text: 'Debe seleccionar un usuario',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
        },
    });
    return;
  }

  // ✅ CERRAR MODAL PRIMERO
  dialogPermisos.value = false;

  // ✅ Esperar un momento para que el modal se cierre completamente
  await new Promise(resolve => setTimeout(resolve, 100));

  // ✅ Ahora sí mostrar confirmación
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    html: `
      <div style="text-align: left;">
        <p>Vas a <strong style="color: #ce501b;">QUITAR</strong> el permiso:</p>
        <p style="font-weight: bold; color: #1976d2; margin: 10px 0;">${permisoActual.value}</p>
        <p>Del usuario/grupo seleccionado en la carpeta:</p>
        <p style="font-weight: bold; margin: 10px 0;">${contextNode.value.name}</p>
      </div>
    `,
    icon: 'warning',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonText: 'Sí, quitar permiso',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    reverseButtons: false,
    width: '500px',
    customClass: {
      title: 'swal-title-custom',
      container: 'swal-sobre-modal',
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar'
    },
  });

  if (result.isConfirmed) {
    try {
      const idUsuarioSesion = localStorage.getItem('idUsuario');

      // Mostrar loading
      Swal.fire({
        title: 'Quitando permiso...',
        allowOutsideClick: false,
        customClass: {
          loader: 'swal-loader-custom',
          title: 'swal-title-custom'
        },
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await axios.post(
        buildApiUrl(`/api/Grupos/quitar-permiso?idUsuarioSesion=${idUsuarioSesion}`),
        {
          idGrupo: usuarioSeleccionado.value,
          tocId: contextNode.value.tocId
        }
      );

      Swal.close();

      if (response.data.success) {
        await Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Éxito!',
          text: 'Permiso eliminado exitosamente',
          timer: 2000,
          confirmButtonColor: '#ce501b',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal',
            confirmButton: 'swal-btn-confirmar'
          },
          showConfirmButton: true
        });
        
        // ✅ Resetear valores después de cerrar todo
        permisoActual.value = '---';
        permisoSeleccionado.value = null;
        usuarioSeleccionado.value = null;
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudo quitar el permiso',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        });
      }
    } catch (error) {
      Swal.close();
      //console.error('Error al quitar permiso:', error); //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || 'Hubo un problema al quitar el permiso',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }
  } else {
    // ✅ Si cancela, volver a abrir el modal
    dialogPermisos.value = true;
  }
};



const obtenerArchivosNoIndexados = async (tocPadre, plantillaId) => {
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    
       // ✅ AGREGAR LOGS PARA DEBUG
      /* // Usarlo solo para ver los errores en el testeo de Software
      console.log('=== LLAMANDO API NO INDEXADOS ===');
      console.log('tocPadre:', tocPadre);
      console.log('plantillaId:', plantillaId);
      console.log('filtro: 0 (no indexados)');
      */
    const response = await axios.post(
      buildApiUrl(`/api/File/archivos-por-filtro?idUsuarioSesion=${idUsuarioSesion}`),
      {
        tocPadre: tocPadre,
        plantillaId: plantillaId,
        filtro: "0"  // "0" = No indexados
      }
    );
    
    if (response.data.success) {
      documentosNoIndexados.value = response.data.data;  // ✅ ASIGNAR aquí
      //console.log('Archivos no indexados:', documentosNoIndexados.value);  //Usarlo solo para ver los errores en el testeo de Software
    } else {
      documentosNoIndexados.value = [];  // ✅ Vaciar si no hay datos
    }
  } catch (error) {
    //console.error('Error al cargar no indexados:', error);   //Usarlo solo para ver los errores en el testeo de Software
    documentosNoIndexados.value = [];  // ✅ Vaciar en caso de error
  }
};

// Ejemplo para obtener archivos indexados
const obtenerArchivosIndexados = async (tocPadre, plantillaId) => {
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    
    const response = await axios.post(
      buildApiUrl(`/api/File/archivos-por-filtro?idUsuarioSesion=${idUsuarioSesion}`),
      {
        tocPadre: tocPadre,
        plantillaId: plantillaId,
        filtro: "1"  // "1" = Indexados
      }
    );
    
    if (response.data.success) {
      documentosIndexados.value = response.data.data;  // ✅ ASIGNAR aquí
      //console.log('Archivos indexados:', documentosIndexados.value);  //Usarlo solo para ver los errores en el testeo de Software
    } else {
      documentosIndexados.value = [];  // ✅ Vaciar si no hay datos
    }
  } catch (error) {
    //console.error('Error al cargar indexados:', error);   //Usarlo solo para ver los errores en el testeo de Software
    documentosIndexados.value = [];  // ✅ Vaciar en caso de error
  }
};


const generarAutoejecutable = async () => {
  showContextMenu.value = false;

  const idUsuarioSesion = localStorage.getItem('idUsuario');

  if (!idUsuarioSesion) {
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'No se pudo obtener la información del usuario en sesión',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal'
      }
    });
    return;
  }

  // ✅ UN SOLO modal: confirmación + checkbox juntos
  const result = await Swal.fire({
    title: '¿Generar Auto Ejecutable?',
    html: `Se generará el autoejecutable para: <b>${contextNode.value.name}</b>
      <div style="text-align:left; margin-top:16px;">
        <label style="display:flex; align-items:center; gap:8px; cursor:pointer; font-size:14px;">
          <input type="checkbox" id="swal-convertir-pdf" style="width:18px; height:18px; accent-color:#ce501b;">
          Convertir imágenes (JPG, PNG, TIF) a PDF
        </label>
      </div>`,
    icon: 'question',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonText: 'Generar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    customClass: {
      title: 'swal-title-custom',
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
    },
    preConfirm: () => ({
      convertirAPdf: document.getElementById('swal-convertir-pdf')?.checked === true
    })
  });

  if (!result.isConfirmed) return;

const convertirAPdf = result.value?.convertirAPdf === true;

  // 🚀 Lanzar la generación/descarga en SEGUNDO PLANO (no se espera).
  // El usuario puede seguir trabajando; el widget flotante muestra el progreso.
  procesarAutoejecutable({
    tocId: contextNode.value.tocId,
    nombre: contextNode.value.name,
    convertirAPdf 
  });

  // Aviso breve NO bloqueante (toast)
  Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'info',
    iconColor: '#ce501b',
    title: 'Generando en segundo plano…',
    text: 'Puedes seguir usando el sistema',
    timer: 2800,
    showConfirmButton: false,
    customClass: { container: 'swal-sobre-modal' }
  });
};



const busquedaCarpeta = async () => {
  showContextMenu.value = false;
  
  let templateId = contextNode.value.templateId || 0;
  
  if (!templateId && contextNode.value.children && contextNode.value.children.length > 0) {
    const hijoConTemplate = contextNode.value.children.find(child => child.templateId && child.templateId > 0);
    if (hijoConTemplate) templateId = hijoConTemplate.templateId;
  }
  
  if (!templateId) templateId = props.templateId || 0;

  try {
    const response = await axios.get(
      buildApiUrl(`/api/Plantillas/estructuraBuscar/${templateId}/${contextNode.value.tocId}`)
    );

    if (response.data.success && response.data.data.length > 0) {
      emit('cambiar-tab', {
        tab: 'busquedaAvanzada',
        plantillaId: response.data.plantillaId || parseInt(templateId),  // ← Del API
        tocId: contextNode.value.tocId,
        nombreCarpeta: contextNode.value.name,
        estructuraCargada: response.data.data
      });
    } else {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Sin plantilla',
        confirmButtonColor: '#ce501b',
        text: 'Esta carpeta no tiene una plantilla asignada.',
        customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'
        }
      });
    }
  } catch (error) {
    //console.error('Error al cargar estructura:', error);  //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({ 
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'No se pudo obtener la estructura.',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
     });
  }
};


// Función para seleccionar/deseleccionar un documento
const toggleDocumento = (tocId) => {
  const index = documentosSeleccionados.value.indexOf(tocId);
  if (index === -1) {
    documentosSeleccionados.value.push(tocId);
  } else {
    documentosSeleccionados.value.splice(index, 1);
  }
};

// Función para seleccionar/deseleccionar todos
const toggleSeleccionarTodos = (seleccionar) => {
  if (seleccionar) {
    documentosSeleccionados.value = documentosNoIndexados.value.map(doc => doc.tocId);
  } else {
    documentosSeleccionados.value = [];
  }
};

// Función para seleccionar/deseleccionar todos (tab Indexados)
const toggleSeleccionarTodosIndexados = (seleccionar) => {
  if (seleccionar) {
    documentosIndexadosSeleccionados.value = documentosIndexados.value.map(doc => doc.tocId);
  } else {
    documentosIndexadosSeleccionados.value = [];
  }
};


// ── Desindexación: selección y navegación en la lista de Indexados ──
const toggleDocumentoIndexado = (tocId) => {
  const index = documentosIndexadosSeleccionados.value.indexOf(tocId);
  if (index === -1) {
    documentosIndexadosSeleccionados.value.push(tocId);
  } else {
    documentosIndexadosSeleccionados.value.splice(index, 1);
  }
};

// Marca un documento indexado SOLO si no está ya seleccionado (no lo desmarca)
const marcarDocumentoIndexado = (tocId) => {
  if (!documentosIndexadosSeleccionados.value.includes(tocId)) {
    documentosIndexadosSeleccionados.value.push(tocId);
  }
};

// Mantener el ítem enfocado visible dentro del scroll de indexados
const scrollItemIndexadoVisible = (index) => {
  virtualIndexadosRef.value?.scrollToIndex(index)
  enfocarListaIndexados()
}

const verDocumentoIndexado = (doc, index) => {
  abrirDocumentoIndexadoVisorInmediatamente(doc, index)
  enfocarListaIndexados()
}

// Navegación por teclado en la lista de documentos indexados
const handleKeyListaIndexados = (event) => {
  const total = documentosIndexados.value.length
  if (total === 0) return

  if (event.key === 'ArrowDown') {
    event.preventDefault()
    indiceFocusListaIndexados.value = Math.min(indiceFocusListaIndexados.value + 1, total - 1)
    scrollItemIndexadoVisible(indiceFocusListaIndexados.value)
    const doc = documentosIndexados.value[indiceFocusListaIndexados.value]
    if (doc) {
      programarAperturaVisor(
        doc, indiceFocusListaIndexados.value, obtenerTemplateIdVisor(), 'indexados'
      )
      if (modoSeleccionDesindexar.value) marcarDocumentoIndexado(doc.tocId)   // ✅ modo activo → marca
    }

  } else if (event.key === 'ArrowUp') {
    event.preventDefault()
    indiceFocusListaIndexados.value = Math.max(indiceFocusListaIndexados.value - 1, 0)
    scrollItemIndexadoVisible(indiceFocusListaIndexados.value)
    const doc = documentosIndexados.value[indiceFocusListaIndexados.value]
    if (doc) {
      programarAperturaVisor(
        doc, indiceFocusListaIndexados.value, obtenerTemplateIdVisor(), 'indexados'
      )
      if (modoSeleccionDesindexar.value) marcarDocumentoIndexado(doc.tocId)   // ✅ modo activo → marca
    }

  } else if (event.key === 'Enter' || event.key === ' ') {
    // ✅ Solo marca/desmarca — no cambia el visor
    event.preventDefault()
    if (indiceFocusListaIndexados.value >= 0) {
      const doc = documentosIndexados.value[indiceFocusListaIndexados.value]
      if (doc) toggleDocumentoIndexado(doc.tocId)
    }

  } else if (event.key === 'Tab') {
    event.preventDefault()
    indiceFocusBotones.value = 0
    nextTick(() => btnGuardarRef.value?.$el?.focus())
  }
}



// Flecha abajo: expandir carpeta + cargar + seleccionar + mover foco al siguiente
const handleArrowDown = (event, activatorProps) => {
  // Verificar si el grupo está colapsado mirando el DOM
  const listGroup = event.target.closest('.v-list-group');
  const estaAbierto = listGroup && listGroup.classList.contains('v-list-group--open');

  // Si NO está abierto, expandirlo
  if (!estaAbierto && activatorProps && activatorProps.onClick) {
    activatorProps.onClick(event);
  }

  handleClick();

  // Mover foco al siguiente v-list-item visible
  setTimeout(() => {
    const current = event.target.closest('.v-list-item');
    if (current) {
      const allItems = Array.from(document.querySelectorAll('.v-list-item'));
      const idx = allItems.indexOf(current);
      if (idx >= 0 && idx < allItems.length - 1) {
        allItems[idx + 1].focus();
      }
    }
  }, 300);
};

// Flecha arriba: seleccionar + mover foco al anterior
const handleArrowUp = (event) => {
  setTimeout(() => {
    const current = event.target.closest('.v-list-item');
    if (current) {
      const allItems = Array.from(document.querySelectorAll('.v-list-item'));
      const idx = allItems.indexOf(current);
      if (idx > 0) {
        const itemAnterior = allItems[idx - 1];
        itemAnterior.focus();
        // ✅ Simular click para seleccionar la carpeta y mostrar su contenido
        itemAnterior.click();
      }
    }
  }, 100);
};


// ── Variables para navegación por teclado en botones ──
const btnGuardarRef = ref(null);
const btnCancelarRef = ref(null);
const indiceFocusBotones = ref(-1);

// Navegación con flechas entre botones Guardar / Cancelar
const handleKeyBotones = (event) => {
  if (Swal.isVisible()) return;   // ← AGREGA ESTA LÍNEA
  if (event.key === 'ArrowRight') {
    event.preventDefault();
    indiceFocusBotones.value = 1;
    nextTick(() => btnCancelarRef.value?.$el?.focus());

  } else if (event.key === 'ArrowLeft') {
    event.preventDefault();
    indiceFocusBotones.value = 0;
    nextTick(() => btnGuardarRef.value?.$el?.focus());

  } else if (event.key === 'Enter') {
    event.preventDefault();
    if (indiceFocusBotones.value === 0) {
      guardarIndexacion();
    } else if (indiceFocusBotones.value === 1) {
      cerrarModalIndexacion();
    }
  }
};



// ── Cargar permisos de carpeta del usuario en sesión ──
const cargarPermisosCarpeta = async () => {
  const idUsuario = localStorage.getItem('idUsuario')
  if (!idUsuario) return
  if (idUsuario === '00001') return   // admin: acceso total, no consultar

  const cacheKey   = `permisosCarpetas_${idUsuario}`
  const promiseKey = `__permisosCarpetasPromise_${idUsuario}`

  let permisos = null

  // 1) Intentar leer del cache (localStorage)
  try {
    const cached = localStorage.getItem(cacheKey)
    if (cached) permisos = JSON.parse(cached)
  } catch { permisos = null }

  // 2) Si no hay cache, consultar al API (deduplicado entre instancias del árbol)
  if (!permisos) {
    if (!window[promiseKey]) {
      window[promiseKey] = axios
        .get(buildApiUrl(`/api/Users/obtener-permiso-carpeta/${idUsuario}`))
        .then(resp => {
          const data = (resp.data?.success && Array.isArray(resp.data.data))
            ? resp.data.data
            : []
          localStorage.setItem(cacheKey, JSON.stringify(data))
          return data
        })
        .catch(() => [])
    }
    try { permisos = await window[promiseKey] } catch { return }
  }

  // 3) Buscar el permiso de ESTA carpeta. Si hay varios registros para el
  //    mismo tocId, escritura (2) gana sobre lectura (1).
  if (Array.isArray(permisos) && permisos.length > 0) {
    const delNodo = permisos.filter(p => p.tocId === props.node.tocId)
    if (delNodo.length > 0) {
      esTipoPer.value = Math.max(...delNodo.map(p => p.idTipoPer || 0))
    }
  }
}

// ── Atajo de teclado Ctrl + Alt + G para guardar indexación ──
const handleKeyboardShortcut = (event) => {

  /*  //testeo de teclado para verificar si detecta las teclas correctamente
   console.log('TECLA:', {
    key: event.key,
    code: event.code,
    ctrl: event.ctrlKey,
    alt: event.altKey,
    shift: event.shiftKey,
    altGraph: event.getModifierState?.('AltGraph')
  }) */

  if (Swal.isVisible()) return;   // ← AGREGA ESTA LÍNEA
 

  if (event.altKey && event.code === 'KeyG') {
    event.preventDefault()
    if (dialogIndexacion.value) {
      guardarIndexacion()
      //enfocarPrimerCampo()
    }
  }

  // ✅ Alt + C → mover foco a la lista de documentos
  if (event.altKey && !event.ctrlKey && !event.shiftKey && event.code === 'KeyC') {
    event.preventDefault()
    if (dialogIndexacion.value) {
      enfocarListaDesdeModal()
    }
  }

 // ✅ Alt + T → toggle "Seleccionar todos" en la lista de no indexados
if (event.altKey && event.code === 'KeyT') {
  event.preventDefault()
  if (dialogIndexacion.value && tabIndexacion.value === 'no-indexados') {
    const todosSeleccionados = documentosSeleccionados.value.length === documentosNoIndexados.value.length
      && documentosNoIndexados.value.length > 0
    toggleSeleccionarTodos(!todosSeleccionados)
  }
}


  // ✅ Alt + J → ir a tab Indexados
  if (event.altKey && event.code === 'KeyJ') {
    event.preventDefault()
    if (dialogIndexacion.value) {
      tabIndexacion.value = 'indexados'
    }
  }

  // ✅ Alt + K → ir a tab No Indexados
  if (event.altKey && event.code === 'KeyK') {
    event.preventDefault()
    if (dialogIndexacion.value) {
      tabIndexacion.value = 'no-indexados'
    }
  }

  // ✅ Alt + X → en tab Indexados: activar/desactivar selección para desindexar
  //             en los demás tabs: ir al primer campo del formulario
  if (event.altKey && event.code === 'KeyX') {
    event.preventDefault()
    if (dialogIndexacion.value) {
      if (tabIndexacion.value === 'indexados') {
        modoSeleccionDesindexar.value = !modoSeleccionDesindexar.value

        if (modoSeleccionDesindexar.value) {
          // Enfocar la lista para navegar de inmediato
          nextTick(() => listaIndexadosRef.value?.focus())
          // Marca el documento actual si ya hay uno enfocado
          if (indiceFocusListaIndexados.value >= 0) {
            const doc = documentosIndexados.value[indiceFocusListaIndexados.value]
            if (doc) marcarDocumentoIndexado(doc.tocId)
          }
        }

        // Aviso visual de estado
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: modoSeleccionDesindexar.value ? 'info' : 'success',
          iconColor: '#ce501b',
          title: modoSeleccionDesindexar.value
            ? 'Selección para DESINDEXAR activada (usa las flechas)'
            : 'Selección para desindexar desactivada',
          timer: 1800,
          showConfirmButton: false,
          customClass: { container: 'swal-sobre-modal' }
        })
      } else {
        enfocarPrimerCampo()
      }
    }
  }

  if (event.key === 'Escape') {
    if (dialogIndexacion.value) {
      event.preventDefault()
      cerrarModalIndexacion()
    }
  }
}


const obtenerTemplateIdVisor = () => {
  let templateId = contextNode.value.templateId
  if (!templateId && contextNode.value.children?.length > 0) {
    const hijo = contextNode.value.children.find(c => c.templateId > 0)
    if (hijo) templateId = hijo.templateId
  }
  if (!templateId) templateId = props.templateId
  return templateId
}

const abrirDocumentoVisorInmediatamente = (doc, index, enfocarCampo = false) => {
  indiceFocusLista.value = index
  const templateId = obtenerTemplateIdVisor()
  if (templateId && (visorCache.has(doc.tocId) || prefetchVisorEnCurso.has(doc.tocId))) {
    programarAperturaVisor(doc, index, templateId, 'no-indexados')
  } else if (templateId) {
    if (aperturaVisorTimeout) clearTimeout(aperturaVisorTimeout)
    aperturaVisorTimeout = null
    documentoPendienteVisor = null
    pausarSolicitudesVisorDuranteNavegacion(doc.tocId)
    navegandoVisor = false
    docSeleccionadoVisor.value = doc
    if (DEBUG_PREFETCH_VISOR) console.log('SOLICITUD_VISIBLE_INICIADA:', doc.tocId)
    cargarVisorCarpeta(doc.tocId, templateId)
  }

  if (enfocarCampo) {
    enfocarPrimerCampo()
  }
}

const abrirDocumentoIndexadoVisorInmediatamente = (doc, index) => {
  indiceFocusListaIndexados.value = index
  const templateId = obtenerTemplateIdVisor()
  if (!templateId) return
  if (visorCache.has(doc.tocId) || prefetchVisorEnCurso.has(doc.tocId)) {
    programarAperturaVisor(doc, index, templateId, 'indexados')
    return
  }
  if (aperturaVisorTimeout) clearTimeout(aperturaVisorTimeout)
  aperturaVisorTimeout = null
  documentoPendienteVisor = null
  pausarSolicitudesVisorDuranteNavegacion(doc.tocId)
  navegandoVisor = false
  docSeleccionadoVisor.value = doc
  if (DEBUG_PREFETCH_VISOR) console.log('SOLICITUD_VISIBLE_INICIADA:', doc.tocId)
  cargarVisorCarpeta(doc.tocId, templateId)
}

// Solo muestra el documento en el visor — SIN marcar checkbox
const verDocumento = (doc, index, enfocarCampo = false) => {
  abrirDocumentoVisorInmediatamente(doc, index, enfocarCampo)
  if (!enfocarCampo) enfocarListaNoIndexados()
}




// eslint-disable-next-line no-unused-vars
const importar_carpeta_externa = () => {
  showContextMenu.value = false

  Swal.fire({
    title: 'Importar carpeta externa',
    html: `
      <div id="dropZone" style="
        border: 2px dashed #ce501b; border-radius: 8px; padding: 32px 20px;
        text-align: center; cursor: pointer; background: #fff7f3; margin-top: 10px;">
        <div style="font-size: 40px;">📁</div>
        <p style="margin: 10px 0 4px; font-weight: 600; color: #ce501b;">
          Arrastra aquí la carpeta a importar
        </p>
        <p style="font-size: 12px; color: #888;">
          Incluye carpetas vacías
        </p>
      </div>

      <div style="margin: 14px 0 6px; font-size: 12px; color: #999;">— o —</div>

      <button id="btnSeleccionar" type="button" style="
        background: #004d82; color: #fff; border: none; border-radius: 6px;
        padding: 10px 18px; cursor: pointer; font-size: 13px; font-weight: 600;">
        📂 Seleccionar carpeta
      </button>
      <p style="font-size: 11px; color: #b58; margin-top: 6px;">
        (Al seleccionar, las carpetas vacías no se detectan — usa arrastrar para incluirlas)
      </p>

      <input id="inputCarpeta" type="file" webkitdirectory multiple style="display:none" />

      <div id="dropResumen" style="margin-top: 14px; font-size: 13px; color: #2e7d32; font-weight: 600;"></div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Importar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' },
    didOpen: () => {
      const dropZone = document.getElementById('dropZone')
      const resumen = document.getElementById('dropResumen')
      const btnSeleccionar = document.getElementById('btnSeleccionar')
      const inputCarpeta = document.getElementById('inputCarpeta')

      const mostrarResumen = (arbol) => {
        const contar = (nodo) => 1 + (nodo.subcarpetas || []).reduce((s, x) => s + contar(x), 0)
        window._carpetaImportar = arbol
        resumen.style.color = '#2e7d32'
        resumen.textContent = `✅ "${arbol.nombre}" detectada (${contar(arbol)} carpetas en total)`
      }

      // ── Drag & drop (lee vacías) ──
      dropZone.addEventListener('dragover', (e) => { e.preventDefault(); dropZone.style.background = '#ffe9df' })
      dropZone.addEventListener('dragleave', () => { dropZone.style.background = '#fff7f3' })
      dropZone.addEventListener('drop', async (e) => {
        e.preventDefault()
        dropZone.style.background = '#fff7f3'
        const items = e.dataTransfer.items
        if (!items || items.length === 0) return
        const entry = items[0].webkitGetAsEntry()
        if (!entry || !entry.isDirectory) {
          resumen.style.color = '#e24b4a'
          resumen.textContent = '⚠️ Debes arrastrar una CARPETA, no un archivo'
          window._carpetaImportar = null
          return
        }
        mostrarResumen(await leerCarpetaRecursivo(entry))
      })

      // ── Botón seleccionar (NO lee vacías) ──
      btnSeleccionar.addEventListener('click', () => inputCarpeta.click())
      inputCarpeta.addEventListener('change', (e) => {
        const files = Array.from(e.target.files)
        if (!files.length) {
          resumen.style.color = '#e24b4a'
          resumen.textContent = '⚠️ No se detectaron carpetas (¿están vacías? usa arrastrar)'
          window._carpetaImportar = null
          return
        }
        mostrarResumen(construirArbolDesdeArchivos(files))
      })
    },
    preConfirm: () => {
      if (!window._carpetaImportar) {
        Swal.showValidationMessage('Primero arrastra o selecciona una carpeta válida')
        return false
      }
      return window._carpetaImportar
    }
  }).then(async (result) => {
    if (!result.isConfirmed || !result.value) return

    const arbol = result.value
    window._carpetaImportar = null

    const idUsuarioSesion = localStorage.getItem('idUsuario')

    Swal.fire({
      title: 'Importando carpetas...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
      customClass: { container: 'swal-sobre-modal' }
    })

    try {
      const { data } = await axios.post(
        `/api/Upload/importar-carpeta-externa?idUsuarioSesion=${idUsuarioSesion}`,
        {
          parentId: contextNode.value.tocId,
          carpetas: [arbol]
        }
      )

      Swal.close()
      Swal.fire({
        icon: 'success', iconColor: '#2e7d32', title: 'Importación completa',
        text: data.mensaje || 'Carpetas importadas correctamente',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      })
     
      emit('folder-selected', null) //resetear el pintado de la selección de carpeta para que se vea la nueva importación

      emit('reload-subcarpetas', contextNode.value.tocId)
      emit('expand-node', contextNode.value.tocId)
      emit('folder-selected', contextNode.value)
    } catch (error) {
      Swal.close()
      Swal.fire({
        icon: 'error', iconColor: '#e24b4a', title: 'Error al importar',
        text: error.response?.data?.mensaje || 'No se pudieron importar las carpetas',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      })
    }
  })
}


// ── Lee recursivamente una carpeta (FileSystemDirectoryEntry), incluyendo vacías ──
const leerCarpetaRecursivo = (directoryEntry) => {
  return new Promise((resolve) => {
    const reader = directoryEntry.createReader()
    const subcarpetas = []

    const leerLote = () => {
      reader.readEntries(async (entries) => {
        if (entries.length === 0) {
          resolve({ nombre: directoryEntry.name, subcarpetas })
          return
        }

        for (const entry of entries) {
          if (entry.isDirectory) {
            const sub = await leerCarpetaRecursivo(entry)
            subcarpetas.push(sub)
          }
          // Los archivos se ignoran (solo queremos carpetas)
        }

        leerLote()  // readEntries entrega en lotes; seguir hasta vaciar
      })
    }

    leerLote()
  })
}



// ── Reconstruye el árbol de carpetas desde rutas de archivos (webkitdirectory) ──
const construirArbolDesdeArchivos = (files) => {
  const nombreRaiz = files[0].webkitRelativePath.split('/')[0]
  const raiz = { nombre: nombreRaiz, _hijos: {} }

  for (const file of files) {
    const partes = file.webkitRelativePath.split('/')
    partes.pop()          // quitar el archivo
    partes.shift()        // quitar la raíz (ya la tenemos)

    let nivel = raiz
    for (const parte of partes) {
      if (!nivel._hijos[parte]) nivel._hijos[parte] = { nombre: parte, _hijos: {} }
      nivel = nivel._hijos[parte]
    }
  }

  const convertir = (nodo) => ({
    nombre: nodo.nombre,
    subcarpetas: Object.values(nodo._hijos).map(convertir)
  })

  return convertir(raiz)
}


// Cuando el upload en segundo plano termina, recargar la carpeta automáticamente
watch(pendingReloadTocId, (newTocId) => {
  if (!newTocId) return
  emit('reload-subcarpetas', newTocId)
  if (contextNode.value) emit('folder-selected', contextNode.value)
  pendingReloadTocId.value = null
})


onMounted(async () => {
  console.info('[DIAG-ARBOL-20260722] treeNode actualizado cargado')
  AccesoImportar.value = Number(localStorage.getItem('importacion'));
  AccesoBusqueda.value = Number(localStorage.getItem('busqueda')) === 1;
  esAdmin.value = localStorage.getItem('idUsuario') === '00001';

  // Aquí se obtiene el permiso de la carpeta para el usuario actual.
  await cargarPermisosCarpeta();

  // ✅ Registrar atajo de teclado
  document.addEventListener('keydown', handleKeyboardShortcut)
  
});

onUnmounted(() => {
  limpiarSesionPointer()
  void limpiarEstadoPdfCarpeta()
  // ✅ Limpiar atajo de teclado
  document.removeEventListener('keydown', handleKeyboardShortcut)
})

</script>

<style scoped>
.tree-folder-selected {
  background-color: rgba(33, 150, 243, 0.12) !important;
  color: #004d82 !important;
}

.tree-folder-draggable {
  cursor: grab;
}

.tree-folder-dragging {
  cursor: grabbing !important;
}

:global(body.tree-folder-pointer-dragging),
:global(body.tree-folder-pointer-dragging *) {
  cursor: grabbing !important;
  user-select: none !important;
}

/* ✅ ESTILOS PARA INDENTACIÓN JERÁRQUICA */
:deep(.v-list-group__items) {
  padding-left: 16px !important;
}

:deep(.v-list-group .v-list-group__items .v-list-item) {
  padding-left: 8px !important;
}

/* Línea vertical para mostrar jerarquía (opcional) */
:deep(.v-list-group__items) {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  margin-left: 12px;
}
</style>

<style>
  .textLayer {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    line-height: 1;
    text-align: initial;
    isolation: isolate;
    user-select: text;
  }

  .textLayer span,
  .textLayer br {
    color: transparent;
    position: absolute;
    white-space: pre;
    cursor: text;
    transform-origin: 0 0;
    letter-spacing: 0;
    word-spacing: 0;
    box-sizing: border-box;
  }

  .textLayer ::selection { background: rgba(0, 100, 255, 0.35); }
  .textLayer .endOfContent {
    display: block;
    position: absolute;
    inset: 100% 0 0;
    z-index: -1;
    cursor: default;
    user-select: none;
  }
  .textLayer .endOfContent.active { top: 0; }

  /* En un archivo CSS global o en un <style> SIN scoped */
.swal-sobre-modal {
  z-index: 3000 !important;
}

.swal-btn-confirmar {
  color: white !important;
}

.swal-btn-cancelar {
  color: white !important;
}

.swal-white-btn {
  color: #ffffff !important;
}

</style>

<style>
  
.swal-title-custom {
  color: #ce501b !important;
  font-size: 1.3rem !important;
}

.swal-text-custom {
  color: #555555 !important;
  font-size: 0.95rem !important;
}

.swal-btn-custom {
  background-color: #ce501b !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
}

.swal-btn-custom:hover {
  background-color: #DD8561 !important;
}

.swal-loader-custom {
  border-color: #ce501b transparent transparent transparent !important;
}

.btn-quitar {
  background-color: #FEEFEA !important;
  color: #ce501b !important;
  font-weight: 600 !important;
}

.btn-quitar:hover {
  background-color: #fdddd3 !important;
}

/* Dialog indexación de carpeta con visor */
.dialog-indexacion-carpeta .v-overlay__content {
  max-height: 97vh !important;
  height: 97vh !important;
  max-width: 1400px !important;
  width: 97vw !important;
  margin: 0 !important;
}
.dialog-indexacion-carpeta .v-overlay__content .v-card {
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden !important;
}

.doc-item-focused {
  background-color: #e3f2fd !important;
  outline: 2px solid #1976d2;
  outline-offset: -2px;
}


.btn-focused {
  outline: 2px solid #1976d2 !important;
  outline-offset: 2px !important;
}

.tree-folder-drop-target {
  background-color: #e3f2fd !important;
  outline: 2px solid #1976d2;
  outline-offset: -2px;
}

.tree-folder-pointer-card {
  position: fixed;
  z-index: 99999;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 280px;
  height: 34px;
  padding: 0 10px;
  pointer-events: none;

  background: #e3f2fd;
  border: 1px solid #1976d2;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.25);
  opacity: 1;
}

.tree-folder-pointer-card__icon {
  flex: 0 0 auto;
  color: #1976d2;
  font-size: 18px;
}

.tree-folder-pointer-card__name {
  overflow: hidden;
  color: #004d82;
  font-size: 13px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}


</style>
